import deepClone from 'deep-clone';

/*  This set of definitions corresponds to the final UIX deisgn */

export const lessonTypes = [

    { type: 'Grammar Lesson',
        init: { subtitle: '-- subtitle --', levelTitle: '1', tags: '', notes: '', listingLabel: '', pageSize: { width: 1200, height: 800 } },
        sections: [
            { type: 'Start', init: { name: 'Start', modes: ['step', 'autoplay'], tags: '', notes: '', notInSectionNav: true },
                pages: [
                    { type: 'LessonStart', init: { background: 'Start', nextButton: 'none' },
                        steps: [
                            { elements: [
                                { type: 'startPageTitle', name: 'startPageTitle' },
                                { type: 'directionsText', name: 'explanation', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Explanation', value: '', links: [], styles: [] },
                                    ] } },
                                { type: 'startButton', name: 'start' },
                                { type: 'layoutBox', name: 'footer' },
                            ] },
                        ],
                    },
                    { type: 'LessonGoal', init: { background: 'Start', nextButton: 'fadeUp' },
                        steps: [
                            { elements: [
                                { type: 'goalTitle', name: 'title' },
                                { type: 'text', name: 'intro' },
                                { type: 'goalText', name: 'goal' },
                            ] },
                        ],
                    },
                    { type: 'LessonGoalWithImage', init: { background: 'Start', nextButton: 'fadeUp' },
                        steps: [
                            { elements: [
                                { type: 'goalTitle', name: 'title', value: 'Goal'},
                                { type: 'text', name: 'intro', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Text', value: 'You’ll be able to say these kinds of sentences at the end of this lesson!', links: [], styles: [] },
                                    ] } },
                                { type: 'image', name: 'image' },
                                { type: 'layoutBox', name: 'sentencesBox' },
                                { type: 'conversationAudio', name: 'sentence1' },
                                { type: 'conversationAudio', name: 'sentence2' },
                                { type: 'conversationAudio', name: 'sentence3' },
                            ] },
                        ],
                    },
                ],
            },
            { type: 'Vocab', init: { name: 'Vocab', modes: ['step', 'autoplay'], tags: '', notes: '' },
                pages: [
                    { type: 'VocabIntro',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Action', value: 'Let\'s review some words we will use in this lesson', links: [], styles: [] },
                                    ] } },

                                { type: 'vocabIntro', name: 'vocabIntro' },
                            ] },
                        ],
                    },
                    { type: 'VocabWords',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToAction', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Action', value: 'Let’s review some words', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directions', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Click on a word to check its meaning', links: [], styles: [] },
                                    ] } },
                                { type: 'vocabCard', name: 'vocabCard1' },
                                { type: 'vocabCard', name: 'vocabCard2' },
                                { type: 'vocabCard', name: 'vocabCard3' },
                            ] },
                        ],
                    },
                ],
            },
            { type: 'Pattern', init: { name: 'Pattern', modes: ['step', 'autoplay'], tags: '', notes: '' },
                pages: [
                    { type: 'PatternIntro',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to ction', value: 'Let\'s meet this lesson\'s pattern', links: [], styles: [] },
                                    ] } },
                                { type: 'lessonIntro', name: 'lessonIntro' },
                            ] },
                        ],
                    },
                    { type: 'PatternSummary',
                        steps: [
                            { elements: [
                                { type: 'patternTitle', name: 'patternTitle' },
                                { type: 'patternVariantsSummary', name: 'patternVariantsSummary' },
                            ] },
                        ],
                    },
                    { type: 'PatternIntroAnimation',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToAction', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Title', value: 'Lesson', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directions', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: "Let's meet this lesson's pattern", links: [], styles: [] },
                                    ] } },
                                { type: 'introductoryVerbConjugation', name: 'introductoryAnimation' },
                            ] },
                        ],
                    },
                    { type: 'LessonPage',
                        steps: [
                            { elements: [
                            ] },
                        ],
                    },
                    { type: 'PatternVariants', init: { optional: false },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToAction', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Title', value: 'Variants', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directions', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Check the table below for the variations of this pattern.', links: [], styles: [] },
                                    ] } },
                                { type: 'variantsTable', name: 'variantsTable', group: 'navigation', size: '100%' },
                                { type: 'variantEntry', name: 'variant1', size: '100%', managedByPage: true },
                                { type: 'variantEntry', name: 'variant2', size: '100%', managedByPage: true },
                                { type: 'variantEntry', name: 'variant3', size: '100%', managedByPage: true },
                            ] },
                        ],
                    },
                    { type: 'AvancedPatternVariants', init: { optional: false },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToAction', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Title', value: 'Variants', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directions', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Check the table below for the variations of this pattern.', links: [], styles: [] },
                                    ] } },
                                { type: 'advancedVariantsTable', name: 'variantsTable', group: 'navigation', size: '100%' },
                                { type: 'advancedVariantEntry', name: 'variant1', size: '100%', managedByPage: true },
                            ] },
                        ],
                    },
                    // { type: 'MiniLessonTable', init: { optional: true },
                    //     steps: [
                    //         { elements: [
                    //             { type: 'callToActionText', name: 'callToAction', size: '100%', init:
                    //                 { fields: [
                    //                     { name: 'text', type: 'text', label: 'Title', value: 'Mini lessons', links: [], styles: [] },
                    //                 ] } },
                    //             { type: 'directionsText', name: 'directions', size: '100%', init:
                    //                 { fields: [
                    //                     { name: 'text', type: 'text', label: 'Directions', value: 'Click on the lesson links below for mini-lessons on each variant.', links: [], styles: [] },
                    //                 ] } },
                    //             { type: 'miniLessonTable', name: 'miniLessonTable', group: 'navigation', size: '100%', init:
                    //                 { fields: [
                    //                     { name: 'endcapLabel', type: 'text', label: 'End-cap label', value: 'Combines with:', links: [], styles: [] },
                    //                     { name: 'endcapText', type: 'text', label: 'End-cap text', value: 'Action verbs & Descriptive verbs', links: [], styles: [] },
                    //                 ] } },
                    //             { type: 'miniLessonTableCard', name: 'miniLessonTableCard1', size: '100%', managedByPage: true },
                    //             { type: 'miniLessonTableCard', name: 'miniLessonTableCard2', size: '100%', managedByPage: true },
                    //             { type: 'miniLessonTableCard', name: 'miniLessonTableCard3', size: '100%', managedByPage: true },
                    //         ] },
                    //     ],
                    // },
                    { type: 'IrregularMiniLessonNav', init: { noLessonFrame: true, optional: true, background: 'Special' },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', size: '110%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Title', value: 'Special Conjugations', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', size: '80%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Click on the lesson links below for special conjugations on each variant.', links: [], styles: [] },
                                    ] } },
                                { type: 'layoutBox', name: 'buttonLayout' },
                                { type: 'miniLessonCard', name: 'miniLessonCard1' },
                                { type: 'miniLessonCard', name: 'miniLessonCard2' },
                                { type: 'miniLessonCard', name: 'miniLessonCard3' },
                                { type: 'miniLessonCard', name: 'miniLessonCard4' },
                                { type: 'miniLessonCard', name: 'miniLessonCard5' },
                            ] },
                        ],
                    },
                    { type: 'IrregularLessonNav', init: { noLessonFrame: true, optional: true, background: 'Special' },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', size: '110%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Title', value: 'Special Conjugations', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', size: '80%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Click on the lesson links below for special conjugations on each variant.', links: [], styles: [] },
                                    ] } },
                                { type: 'layoutBox', name: 'buttonLayout' },
                                { type: 'irregularLessonCard', name: 'lessonCard1' },
                                { type: 'irregularLessonCard', name: 'lessonCard2' },
                                { type: 'irregularLessonCard', name: 'lessonCard3' },
                                { type: 'irregularLessonCard', name: 'lessonCard4' },
                                { type: 'irregularLessonCard', name: 'lessonCard5' },
                            ] },
                        ],
                    },
                    // { type: 'ThreeBoxSummary',
                    //     steps: [
                    //         { elements: [
                    //             { type: 'customPatternTitle', name: 'patternTitle' },
                    //             { type: 'summaryBox', name: 'summaryBox' },
                    //             { type: 'summaryTextSection', name: 'textBox' },
                    //             { type: 'summaryEnBulletsSection', name: 'enBullets' },
                    //             { type: 'summaryExamplesSection', name: 'examples' },
                    //             { type: 'layoutBox', name: 'summaryBoxLayout' },
                    //         ] },
                    //     ],
                    // },
                    // { type: 'ThreeBoxSummaryTxtExEx',
                    //     steps: [
                    //         { elements: [
                    //             { type: 'customPatternTitle', name: 'patternTitle' },
                    //             { type: 'summaryBox', name: 'summaryBox' },
                    //             { type: 'summaryTextSection', name: 'textBox' },
                    //             { type: 'summaryExamplesSection', name: 'expressions' },
                    //             { type: 'summaryExamplesSection', name: 'examples' },
                    //             { type: 'layoutBox', name: 'summaryBoxLayout' },
                    //         ] },
                    //     ],
                    // },
                    // { type: 'FourBoxSummary',
                    //     steps: [
                    //         { elements: [
                    //             { type: 'customPatternTitle', name: 'patternTitle' },
                    //             { type: 'summaryBox', name: 'summaryBox' },
                    //             { type: 'summaryTextSection', name: 'textBox' },
                    //             { type: 'summaryEnBulletsSection', name: 'enBullets' },
                    //             { type: 'summaryKoBulletsSection', name: 'koBullets' },
                    //             { type: 'summaryExamplesSection', name: 'examples' },
                    //             { type: 'layoutBox', name: 'summaryBoxLayout' },
                    //         ] },
                    //     ],
                    // },
                ],
            },

            // { type: 'MiniLesson', init: { name: 'MiniLesson', modes: ['step', 'autoplay'], tags: '', notes: '', notInSectionNav: true, miniLesson: true },
            //     pages: [
            //         { type: 'MiniLessonSummary', init: { background: 'Mini Lesson' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'listButton', name: 'listButton', size: '100%' },
            //                     { type: 'customPatternTitle', name: 'customPatternTitle', size: '100%' },
            //                     { type: 'patternSummary', name: 'patternSummary', size: '100%' },
            //                 ] },
            //             ],
            //         },
            //         { type: 'ProcessExamples', init: { background: 'Mini Lesson' }, // dontInstance: true,
            //             steps: [
            //                 { elements: [
            //                     { type: 'listButton', name: 'listButton', size: '100%' },
            //                     { type: 'callToActionText', name: 'callToAction', size: '110%', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Title', value: 'Examples of the conjugation process', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'directionsText', name: 'directions', size: '80%', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Directions', value: 'Click on an example to view it', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'verbConjugation', name: 'processExample1' },
            //                     { type: 'verbConjugation', name: 'processExample2' },
            //                     { type: 'verbConjugation', name: 'processExample3' },
            //                     { type: 'layoutBox', name: 'animationStageBox' },
            //
            //                 ] },
            //             ],
            //         },
            //         { type: 'MiniLessonTestIntro', init: { background: 'Mini Lesson' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'listButton', name: 'listButton', size: '100%' },
            //                     { type: 'miniTestParty', name: 'miniTestParty' },
            //                     { type: 'callToActionText', name: 'callToActionText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Call to action', value: 'Let\'s see how well you\'ve understood...', links: [], styles: [] },
            //                         ] } },
            //                 ] },
            //             ],
            //         },
            //         { type: 'MiniLessonTestPickOne', init: { background: 'Mini Lesson' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'listButton', name: 'listButton', size: '100%' },
            //                     { type: 'callToActionText', name: 'callToActionText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
            //                         ] } },
            //                     { type: 'directionsText', name: 'directionsText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Directions text', value: 'Pick the correct variant.', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'hintButton', name: 'hintButton' },
            //                     { type: 'pickOne', name: 'pickOne' },
            //                 ] },
            //             ],
            //         },
            //         { type: 'MiniLessonTestPhraseBoard', init: { background: 'Mini Lesson' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'listButton', name: 'listButton', size: '100%' },
            //                     { type: 'callToActionText', name: 'callToActionText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
            //                         ] } },
            //                     { type: 'directionsText', name: 'directionsText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Directions text', value: 'Find the phrase with -는 and click the letters in the correct order.', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'hintButton', name: 'hintButton' },
            //                     { type: 'phraseBoard', name: 'phraseBoard' },
            //                 ] },
            //             ],
            //         },
            //         { type: 'MiniLessonTestPhraseSequence', init: { background: 'Mini Lesson' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'listButton', name: 'listButton', size: '100%' },
            //                     { type: 'callToActionText', name: 'callToActionText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
            //                         ] } },
            //                     { type: 'directionsText', name: 'directionsText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Directions text', value: 'Unscramble the sentence.', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'hintButton', name: 'hintButton' },
            //                     { type: 'phraseSequence', name: 'phraseSequence' },
            //                 ] },
            //             ],
            //         },
            //         { type: 'MiniLessonSuccess', init: { background: 'Mini Lesson' },
            //             steps: [
            //                 { elements: [
            //                     { name: 'listButton', type: 'listButton', size: '100%' },
            //                     { name: 'miniLessonDone', type: 'miniLessonDone' },
            //                     { name: 'congratsText', type: 'goodJobText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Excellent text', value: 'Excellent!', links: [], styles: [] },
            //                         ] } },
            //                     { name: 'completionText', type: 'directionsText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Completion text', value: 'You have completed this mini-lesson!', links: [], styles: [] },
            //                         ] } },
            //                 ] },
            //             ],
            //         },
            //     ],
            // },
            // { type: 'IrregularMiniLesson', init: { name: 'IrregularMiniLesson', modes: ['step', 'autoplay'], tags: '', notes: '', notInSectionNav: true, miniLesson: true },
            //     pages: [
            //         { type: 'IrregularIntro', init: { background: 'Special' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'specialListButton', name: 'specialListButton', size: '100%' },
            //                     { type: 'irregularIcon', name: 'irregularIcon' },
            //                     { type: 'irregularTitle', name: 'irregularTitle', size: '100%', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Title', value: 'ㅂ Irregular verbs', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'directionsText', name: 'subtitle', size: '100%', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Explanation', value: 'ㅡ drops when it is followed by -아요 / -어요.', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'staticPattern', name: 'staticPattern' },
            //                     { type: 'patternCallout', name: 'patternCallout' },
            //                 ] },
            //             ],
            //         },
            //         { type: 'IrregularProcessExamples', init: { background: 'Special' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'specialListButton', name: 'specialListButton', size: '100%' },
            //                     { type: 'callToActionText', name: 'callToAction', size: '110%', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Title', value: 'Examples of the conjugation process', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'directionsText', name: 'directions', size: '80%', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Directions', value: 'Click on an example to view it', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'verbConjugation', name: 'processExample1' },
            //                     { type: 'verbConjugation', name: 'processExample2' },
            //                     { type: 'verbConjugation', name: 'processExample3' },
            //                     { type: 'layoutBox', name: 'animationStageBox' },
            //                 ] },
            //             ],
            //         },
            //         { type: 'IrregularLessonTestIntro', init: { background: 'Special' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'specialListButton', name: 'specialListButton', size: '100%' },
            //                     { type: 'miniTestParty', name: 'miniTestParty' },
            //                     { type: 'callToActionText', name: 'callToAction', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Call to action', value: 'Let\'s see how well you\'ve understood...', links: [], styles: [] },
            //                         ] } },
            //                 ] },
            //             ],
            //         },
            //         { type: 'IrregularLessonTestPickOne', init: { background: 'Special' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'specialListButton', name: 'specialListButton', size: '100%' },
            //                     { type: 'callToActionText', name: 'callToActionText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
            //                         ] } },
            //                     { type: 'directionsText', name: 'directionsText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Directions text', value: 'Pick the correct variant.', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'hintButton', name: 'hintButton' },
            //                     { type: 'pickOne', name: 'pickOne' },
            //                 ] },
            //             ],
            //         },
            //         { type: 'IrregularLessonTestPhraseBoard', init: { background: 'Special' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'specialListButton', name: 'specialListButton', size: '100%' },
            //                     { type: 'callToActionText', name: 'callToActionText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
            //                         ] } },
            //                     { type: 'directionsText', name: 'directionsText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Directions text', value: 'Find the phrase with -는 and click the letters in the correct order.', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'hintButton', name: 'hintButton' },
            //                     { type: 'phraseBoard', name: 'phraseBoard' },
            //                 ] },
            //             ],
            //         },
            //         { type: 'IrregularLessonTestPhraseSequence', init: { background: 'Special' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'specialListButton', name: 'specialListButton', size: '100%' },
            //                     { type: 'callToActionText', name: 'callToActionText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
            //                         ] } },
            //                     { type: 'directionsText', name: 'directionsText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Directions text', value: 'Unscramble the sentence.', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'hintButton', name: 'hintButton' },
            //                     { type: 'phraseSequence', name: 'phraseSequence' },
            //                 ] },
            //             ],
            //         },
            //         { type: 'IrregularLessonSuccess', init: { background: 'Special' },
            //             steps: [
            //                 { elements: [
            //                     { type: 'specialListButton', name: 'specialListButton', size: '100%' },
            //                     { type: 'irregularLessonDone', name: 'irregularLessonDone' },
            //                     { type: 'irregularCongratsText', name: 'irregularCongratsText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Congrats text', value: 'Awesome!', links: [], styles: [] },
            //                         ] } },
            //                     { type: 'directionsText', name: 'completionText', init:
            //                         { fields: [
            //                             { name: 'text', type: 'text', label: 'Completion text', value: 'You have completed this irregular-pattern lesson!', links: [], styles: [] },
            //                         ] } },
            //                 ] },
            //             ],
            //         },
            //     ],
            // },

            { type: 'Practice', init: { name: 'Practice', modes: ['step', 'autoplay'], tags: '', notes: '' },
                pages: [
                    { type: 'PracticeIntro',
                        steps: [
                            { elements: [
                                { type: 'practiceIntro', name: 'practiceIntro' },
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: "Let's practice what we have learned!", links: [], styles: [] },
                                    ] } },
                            ] },
                        ],
                    },
                    { type: 'PracticePhraseBoard',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Find the phrase with -는 and click the letters in the correct order.', links: [], styles: [] },
                                    ] } },
                                { type: 'hintButton', name: 'hintButton' },
                                { type: 'phraseBoard', name: 'phraseBoard' },
                            ] },
                        ],
                    },
                    { type: 'PracticePickOne',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Pick the correct variant.', links: [], styles: [] },
                                    ] } },
                                { type: 'hintButton', name: 'hintButton' },
                                { type: 'pickOne', name: 'pickOne' },
                            ] },
                        ],
                    },
                    { type: 'PracticePhraseSequence',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Unscramble the sentence.', links: [], styles: [] },
                                    ] } },
                                { type: 'hintButton', name: 'hintButton' },
                                { type: 'phraseSequence', name: 'phraseSequence' },
                            ] },
                        ],
                    },
                    { type: 'PracticeListening',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Listen closely and select the best response.', links: [], styles: [] },
                                    ] } },
                                { type: 'hintButton', name: 'hintButton' },
                                { type: 'practiceListening', name: 'practiceListening' }
                            ] },
                        ],
                    },
                    { type: 'PracticeTyping',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Listen closely and enter the missing words.', links: [], styles: [] },
                                    ] } },
                                { type: 'hintButton', name: 'hintButton' },
                                { type: 'practiceTyping', name: 'practiceTyping' }
                            ] },
                        ],
                    },
                    { type: 'AdvancedTyping',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Type the translation using the words provided.', links: [], styles: [] },
                                    ] } },
                                { type: 'hintButton', name: 'hintButton' },
                                { type: 'advancedTyping', name: 'advancedTyping' }
                            ] },
                        ],
                    },
                    { type: 'LearnAnIdiom',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: "Culture", links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Learn an idiomatic phrase.', links: [], styles: [] },
                                    ] } },
                                { type: 'idiomImageCard', name: 'idiomImageCard' },
                                { type: 'idiomTextCard', name: 'idiomTextCard' },
                            ] },
                        ],
                    },

                    // { type: 'PracticeUnscramble',
                    //     steps: [
                    //         { elements: [
                    //             { type: 'callToActionText', name: 'callToActionText', init:
                    //                 { fields: [
                    //                     { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
                    //                 ] } },
                    //             { type: 'directionsText', name: 'directionsText', init:
                    //                 { fields: [
                    //                     { name: 'text', type: 'text', label: 'Directions text', value: 'Unscramble the sentence.', links: [], styles: [] },
                    //                 ] } },
                    //             { type: 'hintButton', name: 'hintButton' },
                    //             { type: 'completeThePhrase', name: 'completeThePhrase' },
                    //         ] },
                    //     ],
                    // },
                    // { type: 'PracticeCompleteThePhrase',
                    //     steps: [
                    //         { elements: [
                    //             { type: 'callToActionText', name: 'callToActionText', init:
                    //                 { fields: [
                    //                     { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
                    //                 ] } },
                    //             { type: 'directionsText', name: 'directionsText', init:
                    //                 { fields: [
                    //                     { name: 'text', type: 'text', label: 'Directions text', value: 'Complete the phrase.', links: [], styles: [] },
                    //                 ] } },
                    //             { type: 'hintButton', name: 'hintButton' },
                    //             { type: 'completeThePhrase', name: 'completeThePhrase' },
                    //         ] },
                    //     ],
                    // },
                    { type: 'PracticeDrag',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: "Let's practice!", links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Drag to the correct side.', links: [], styles: [] },
                                    ] } },
                                { type: 'hintButton', name: 'hintButton' },
                                { type: 'drag', name: 'drag' },
                            ] },
                        ],
                    },
                ],
            },
            { type: 'Culture', init: { name: 'Culture', modes: ['step', 'autoplay'], tags: '', notes: '' },
                pages: [
                    { type: 'CultureIntro',
                        steps: [
                            { elements: [
                                { type: 'cultureIntro', name: 'cultureIntro' },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Check the pattern in a song!', links: [], styles: [{ start: 23, end: 27, styledText: 'song', style: 'highlight' }] },
                                    ] } },
                            ] },
                        ],
                    },
                    { type: 'CulturePattern',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: 'Find the pattern in a song!', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: "Let's look at the pattern as it appears in a popular song.", links: [], styles: [] },
                                    ] } },
                                { type: 'cultureExample', name: 'cultureExample' },
                                { type: 'phrase', name: 'example', init:
                                    { fields: [
                                        { name: 'phrase', label: 'Example phrase', type: 'parts',
                                            parts: {
                                                koreanParts: [
                                                    { value: '돌아오는 이번주 금요일에 만', color: 'example' },
                                                    { value: '나요', color: 'pattern' },
                                                ],
                                                englishParts: [
                                                    { value: "Let's meet this coming Friday", color: 'english' },
                                                ],
                                            },
                                        },
                                    ] },
                                },
                            ] },
                        ],
                    },
                    { type: 'CulturePatternInClip',
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: 'Find the pattern in a song!', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: "Let's look at the pattern as it appears in a popular song.", links: [], styles: [] },
                                    ] } },
                                { type: 'cultureExample', name: 'cultureExample' },
                                { type: 'subTitledVideoClip', name: 'subTitledVideoClip' },
                            ] },
                        ],
                    },
                ],
            },
            { type: 'GoalCheck', init: { name: 'GoalCheck', modes: ['step', 'autoplay'], tags: '', notes: '' },
                pages: [
                    { type: 'GoalCheckIntro', init: { noLessonFrame: true, background: 'End', nextButton: 'none' },
                        steps: [
                            { elements: [
                                { type: 'completeGoalText', name: 'completeGoalText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Complete goal text', value: 'Now, let’s complete our goal!', links: [], styles: [] },
                                    ] } },
                                { type: 'startButton', name: 'startButton', init:
                                    { fields: [
                                        { name: 'label', type: 'text', label: 'Label', value: 'Final check', links: [], styles: [] },
                                    ] } },
                            ] },
                        ],
                    },
                    { type: 'GoalCheckUnscramble', init: { background: 'Goal check' },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToActionText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Call to action text', value: 'Check our goal!', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Use the words below to say this in Korean.', links: [], styles: [] },
                                    ] } },
                                { type: 'phraseSequence', name: 'phraseSequence' },
                            ] },
                        ],
                    },
                    { type: 'GoalCheckSuccess', init: { background: 'End', nextButton: 'none' },
                        steps: [
                            { elements: [
                                { type: 'congratsText', name: 'congratsText' },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Good Job! You completed our goal!', links: [], styles: [] },
                                    ] } },
                                { type: 'stamp', name: 'stamp' },
                                { type: 'finishButton', name: 'finishButton' },
                            ] },
                        ],
                    },
                ],
            },
        ],
    },
    { type: 'Hangul Letters',
        init: { subtitle: '-- subtitle --', levelTitle: '1', tags: '', notes: '', listingLabel: '', pageSize: { width: 1200, height: 800 } },
        sections: [
            { type: 'Start', init: { name: 'Start', modes: ['step', 'autoplay'], tags: '', notes: '', notInSectionNav: true },
                pages: [
                    { type: 'LessonStart', init: { background: 'Hangul start', nextButton: 'none' },
                        steps: [
                            { elements: [
                                { type: 'startPageTitle', name: 'startPageTitle' },
                                { type: 'directionsText', name: 'explanation', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Explanation', value: '', links: [], styles: [] },
                                    ] } },
                                { type: 'startButton', name: 'start' },
                                { type: 'layoutBox', name: 'footer' },
                            ] },
                        ],
                    },
                ],
            },
            { type: 'Letters', init: { name: 'Letters', modes: ['step', 'autoplay'], tags: '', notes: '' },
                pages: [
                    { type: 'MeetTheLetters', init: { background: 'Hangul' },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToAction', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Action', value: 'Let’s review some words', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directions', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Click on a word to check its meaning', links: [], styles: [] },
                                    ] } },
                                { type: 'letterCard', name: 'letterCard1' },
                                { type: 'letterCard', name: 'letterCard2' },
                                { type: 'letterCard', name: 'letterCard3' },
                            ] },
                        ],
                    },
                    { type: 'MeetTheWords', init: { background: 'Hangul' },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToAction', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Action', value: 'Let’s review some words', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directions', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Click on a word to check its meaning', links: [], styles: [] },
                                    ] } },
                                { type: 'wordCard', name: 'wordCard' },
                                { type: 'phrase', name: 'word', init:
                                    { style: { koFontWeight: 700, koreanFontSize: '80px', englishFontSize: '20px', enFontWeight: 500 },
                                        mobile: { style: { koFontWeight: 700, koreanFontSize: '50px', englishFontSize: '20px', enFontWeight: 500 } },
                                        fields: [
                                        { name: 'phrase', label: 'Word', type: 'parts',
                                            parts: {
                                                koreanParts: [
                                                    { value: '오이', color: 'blackish' },
                                                ],
                                                englishParts: [
                                                    { value: "Cucumber", color: 'english' },
                                                ],
                                            },
                                        },
                                    ] },
                                },
                                { type: 'helpBubble', name: 'help', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Help', value: 'In the word "오이," the Korean letter "ㅇ" is silent and serves as a placeholder for the absence of a sound.', links: [], styles: [] },
                                        { name: 'placement', type: 'choice', label: 'Placement', choices: ['Above', 'Below', 'Right', 'Left'], value: 'Above' },
                                    ] } },

                            ] },
                        ],
                    },
                    { type: 'MeetTheBatchim', init: { background: 'Hangul' },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToAction', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Action', value: 'Let’s review some words', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directions', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Click on a word to check its meaning', links: [], styles: [] },
                                    ] } },
                                { type: 'batchimCard', name: 'batchimCard1' },
                                { type: 'batchimCard', name: 'batchimCard2' },
                                { type: 'batchimCard', name: 'batchimCard3' },
                                { type: 'annotation', name: 'annotation', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Annotation', value: 'The final consonants  ㄱ,ㅋ,ㄲ sound like ㄱ[k].', links: [], styles: [] },
                                    ] } },
                                { type: 'helpBubble', name: 'help', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Help', value: "In modern Korean, ‘ㄽ’ final consonant actually exists for two completors: '곬' and '옰'.", links: [], styles: [] },
                                        { name: 'placement', type: 'choice', label: 'Placement', choices: ['Above', 'Below', 'Right', 'Left'], value: 'Above' },
                                    ] } },
                            ] },
                        ],
                    },
                ],
            },
            { type: 'Quiz', init: { name: 'Practice', modes: ['step', 'autoplay'], tags: '', notes: '' },
                pages: [
                    { type: 'PickTheLetter', init: { background: 'Hangul' },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToAction', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Action', value: 'Let’s review some words', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directions', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Click on a word to check its meaning', links: [], styles: [] },
                                    ] } },
                                { type: 'pickALetter', name: 'pickALetter' },
                            ] },
                        ],
                    },
                    { type: 'MakeTheWord', init: { background: 'Hangul' },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToAction', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Action', value: 'Let’s review some words', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directions', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Click on a word to check its meaning', links: [], styles: [] },
                                    ] } },
                                { type: 'makeTheWord', name: 'makeTheWord' },
                            ] },
                        ],
                    },
                    { type: 'MatchTheLetters', init: { background: 'Hangul' },
                        steps: [
                            { elements: [
                                { type: 'callToActionText', name: 'callToAction', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Action', value: 'Let’s review some words', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'directions', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions', value: 'Click on a word to check its meaning', links: [], styles: [] },
                                    ] } },
                                { type: 'matchTheLetters', name: 'matchTheLetters' },
                            ] },
                        ],
                    },
                    { type: 'LessonEnd', init: { background: 'Hangul end', nextButton: 'none' },
                        steps: [
                            { elements: [
                                { type: 'congratsText', name: 'congratsText' },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Good Job! You completed our goal!', links: [], styles: [] },
                                    ] } },
                                { type: 'stamp', name: 'stamp' },
                                { type: 'finishButton', name: 'finishButton' },
                            ] },
                        ],
                    },

                ],
            },
        ],
    },
    { type: 'Batchim Lesson',
        init: { subtitle: '-- subtitle --', levelTitle: '1', tags: '', notes: '', listingLabel: '', pageSize: { width: 1200, height: 800 } },
        sections: [
            { type: 'Start', init: { name: 'Start', modes: ['step', 'autoplay'], tags: '', notes: '', notInSectionNav: true },
                pages: [
                    { type: 'LessonStart', init: { background: 'Start', nextButton: 'none' },
                        steps: [
                            { elements: [
                                { type: 'startPageTitle', name: 'startPageTitle' },
                                { type: 'directionsText', name: 'explanation', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Explanation', value: '', links: [], styles: [] },
                                    ] } },
                                { type: 'startButton', name: 'start' },
                                { type: 'layoutBox', name: 'footer' },
                            ] },
                        ],
                    },
                ],
            },
            { type: 'Batchim', init: { name: 'Intro', modes: ['step', 'autoplay'], tags: '', notes: '' },
                pages: [
                    { type: 'StarterImageAndText', init: { noLessonFrame: true, background: 'ImageAndText' },
                        steps: [
                            { elements: [
                                { type: 'imageAndTextTitle', name: 'title', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Title', value: '받침 (Final consonant)', links: [], styles: [] },
                                    ] } },
                                { type: 'imageCard', name: 'imageCard' },
                                { type: 'textCard', name: 'textCard' },
                            ] },
                        ],
                    },
                    { type: 'ImageAndTextEnd', init: { background: 'ImageAndText', nextButton: 'none' },
                        steps: [
                            { elements: [
                                { type: 'congratsText', name: 'congratsText' },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Good Job! You completed our goal!', links: [], styles: [] },
                                    ] } },
                                { type: 'stamp', name: 'stamp' },
                                { type: 'finishButton', name: 'finishButton' },
                            ] },
                        ],
                    },
                ],
            },
        ],
    },
    { type: 'Bridge lessons',
        init: { subtitle: '-- subtitle --', levelTitle: '1', tags: '', notes: '', listingLabel: '', pageSize: { width: 1200, height: 800 } },
        sections: [
            { type: 'Start', init: { name: 'Start', modes: ['step', 'autoplay'], tags: '', notes: '', notInSectionNav: true },
                pages: [
                    { type: 'ImageAndTextStart', init: { noLessonFrame: true, background: 'ImageAndText', nextButton: 'none' },
                        steps: [
                            { elements: [
                                { type: 'hangul', name: 'hangul' },
                                { type: 'text', name: 'title', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Title', value: 'Intro to Hangul', links: [], styles: [] },
                                    ] } },
                                { type: 'directionsText', name: 'intro', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Intro text', value: 'Before we embark on our exciting...', links: [], styles: [] },
                                    ] } },
                                { type: 'startButton', name: 'start' },
                            ] },
                        ],
                    },
                ],
            },
            { type: 'Grammar intro', init: { name: 'Intro', modes: ['step', 'autoplay'], tags: '', notes: '' },
                pages: [
                    { type: 'StarterImageAndText', init: { noLessonFrame: true, background: 'ImageAndText' },
                        steps: [
                            { elements: [
                                { type: 'imageAndTextTitle', name: 'title', size: '100%', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Title', value: '받침 (Final consonant)', links: [], styles: [] },
                                    ] } },
                                { type: 'imageCard', name: 'imageCard' },
                                { type: 'textCard', name: 'textCard' },
                            ] },
                        ],
                    },
                    { type: 'ImageAndTextEnd', init: { background: 'ImageAndText', nextButton: 'none', noLessonFrame: true },
                        steps: [
                            { elements: [
                                { type: 'congratsText', name: 'congratsText' },
                                { type: 'directionsText', name: 'directionsText', init:
                                    { fields: [
                                        { name: 'text', type: 'text', label: 'Directions text', value: 'Good Job! You completed our goal!', links: [], styles: [] },
                                    ] } },
                                { type: 'stamp', name: 'stamp' },
                                { type: 'finishButton', name: 'finishButton' },
                            ] },
                        ],
                    },
                ],
            },
        ],
    },


    // { type: 'Culture Lesson',
    //     init: { subtitle: '-- subtitle --', levelTitle: '1', tags: '', notes: '', listingLabel: '', pageSize: { width: 1200, height: 800 } },
    //     sections: [
    //         { type: 'Start', init: { name: 'Start', modes: ['step', 'autoplay'], tags: '', notes: '', notInSectionNav: true },
    //             pages: [
    //                 { type: 'CultureStart', init: { background: 'Start', nextButton: 'none' },
    //                     steps: [
    //                         { elements: [
    //                             { type: 'startPageTitle', name: 'startPageTitle' },
    //                             { type: 'directionsText', name: 'explanation', size: '100%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Explanation', value: '', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'startButton', name: 'start' },
    //                             { type: 'layoutBox', name: 'footer' },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'CultureGoal', init: { background: 'Start', nextButton: 'fadeUp' },
    //                     steps: [
    //                         { elements: [
    //                             { type: 'goalTitle', name: 'title' },
    //                             { type: 'text', name: 'intro' },
    //                             { type: 'goalText', name: 'goal' },
    //                         ] },
    //                     ],
    //                 },
    //             ],
    //         },
    //         { type: 'Vocab', init: { name: 'Vocab', modes: ['step', 'autoplay'], tags: '', notes: '' },
    //             pages: [
    //                 { type: 'CultureVocabIntro',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToActionText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Action', value: 'Let\'s review some words we will use in this lesson', links: [], styles: [] },
    //                                 ] } },
    //
    //                             { type: 'vocabIntro', name: 'vocabIntro' },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'CultureVocabWords',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToAction', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Action', value: 'Let’s review some words', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'directionsText', name: 'directions', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions', value: 'Click on a word to check its meaning', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'vocabCard', name: 'vocabCard1' },
    //                             { type: 'vocabCard', name: 'vocabCard2' },
    //                             { type: 'vocabCard', name: 'vocabCard3' },
    //                         ] },
    //                     ],
    //                 },
    //             ],
    //         },
    //         { type: 'Meaning', init: { name: 'Meaning', modes: ['step', 'autoplay'], tags: '', notes: '' },
    //             pages: [
    //                 { type: 'idiomIntro',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToActionText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Call to action', value: 'Let\'s learn what the idiom means.', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'idiomIntro', name: 'idiomIntro' },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'CultureGuessAnimation',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToAction', size: '100%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Title', value: 'Guess what it means', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'directionsText', name: 'directions', size: '100%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions', value: 'Check what each word means', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'introductoryVerbConjugation', name: 'introductoryAnimation' },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'ListenToAConversation',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToAction', size: '100%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Title', value: 'Guess what it means', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'directionsText', name: 'directions', size: '100%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions', value: 'Listen and guess its meaning through a short conversation.', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'conversationAudio', name: 'sentence1' },
    //                             { type: 'conversationAudio', name: 'sentence2' },
    //                             { type: 'conversationAudio', name: 'sentence3' },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'MeaningSummary',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'customPatternTitle', name: 'patternTitle' },
    //                             { type: 'summaryBox', name: 'summaryBox' },
    //                             { type: 'summaryTextSection', name: 'textBox' },
    //                             { type: 'summaryExamplesSection', name: 'expressions' },
    //                             { type: 'summaryExamplesSection', name: 'examples' },
    //                             { type: 'layoutBox', name: 'summaryBoxLayout' },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'MeetThePattern',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToAction', size: '100%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Title', value: 'Lesson', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'directionsText', name: 'directions', size: '100%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions', value: "Let’s meet the lesson's pattern!", links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'introductoryVerbConjugation', name: 'meetThePattern' },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'SimilarExpressions', init: { },
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToAction', size: '110%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Title', value: 'Let’s check the similar expressions', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'directionsText', name: 'directions', size: '80%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions', value: 'Click on each expression to see how they differ...', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'verbConjugation', name: 'expression1' },
    //                             { type: 'verbConjugation', name: 'expression2' },
    //                             { type: 'verbConjugation', name: 'expression3' },
    //                             { type: 'layoutBox', name: 'animationStageBox' },
    //
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'ListenAndGuess',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToAction', size: '100%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Title', value: 'Listen to a conversation', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'directionsText', name: 'directions', size: '100%', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions', value: "Let's review the expression in a conversation one more time...", links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'conversationAudio', name: 'sentence1' },
    //                             { type: 'conversationAudio', name: 'sentence2' },
    //                             { type: 'conversationAudio', name: 'sentence3' },
    //                         ] },
    //                     ],
    //                 },
    //             ],
    //         },
    //         { type: 'Usage', init: { name: 'Usage', modes: ['step', 'autoplay'], tags: '', notes: '' },
    //             pages: [
    //                 { type: 'UsageIntro',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToActionText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Call to ction', value: "Let's explore some uses of this expression...", links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'lessonIntro', name: 'lessonIntro' },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'SentenceFormIntro',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToAction', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Call to action', value: 'Sentence Form', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'directionsText', name: 'directions', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions', value: 'This idiom is used in a sentence commonly as shown in the examples below...', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'phrase', name: 'example1', init:
    //                                 { fields: [
    //                                     { name: 'phrase', label: 'Example 1', type: 'parts',
    //                                         parts: {
    //                                             koreanParts: [
    //                                                 { value: '매뉴', color: 'example' },
    //                                             ],
    //                                             englishParts: [
    //                                                 { value: 'menu', color: 'english' },
    //                                             ],
    //                                         },
    //                                     },
    //                                 ] },
    //                             },
    //                             { type: 'phrase', name: 'example2', init:
    //                                 { fields: [
    //                                     { name: 'phrase', label: 'Example 2', type: 'parts',
    //                                         parts: {
    //                                             koreanParts: [
    //                                                 { value: '색갈', color: 'example' },
    //                                             ],
    //                                             englishParts: [
    //                                                 { value: 'color', color: 'english' },
    //                                             ],
    //                                         },
    //                                     },
    //                                 ] },
    //                             },
    //                             { type: 'phrase', name: 'example3', init:
    //                                 { fields: [
    //                                     { name: 'phrase', label: 'Example 3', type: 'parts',
    //                                         parts: {
    //                                             koreanParts: [
    //                                                 { value: '그 쟙', color: 'example' },
    //                                             ],
    //                                             englishParts: [
    //                                                 { value: 'that house', color: 'english' },
    //                                             ],
    //                                         },
    //                                     },
    //                                 ] },
    //                             },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'SentenceForm',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'sentenceForm', name: 'sentenceForm' },
    //                             { type: 'sentenceFormExample', name: 'example1' },
    //                             { type: 'sentenceFormExample', name: 'example2' },
    //                             { type: 'sentenceFormExample', name: 'example3' },
    //                             { type: 'layoutBox', name: 'animationStageBox' },
    //                         ] },
    //                     ],
    //                 },
    //             ],
    //         },
    //         { type: 'Culture', init: { name: 'Culture', modes: ['step', 'autoplay'], tags: '', notes: '' },
    //             pages: [
    //                 { type: 'CultureIntro',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'cultureIntro', name: 'cultureIntro' },
    //                             { type: 'directionsText', name: 'directionsText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions text', value: 'Check the pattern in a song!', links: [], styles: [{ start: 23, end: 27, styledText: 'song', style: 'highlight' }] },
    //                                 ] } },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'CulturePattern',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToActionText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Call to action text', value: 'Find the pattern in a song!', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'directionsText', name: 'directionsText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions text', value: "Let's look at the pattern as it appears in a popular song.", links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'cultureExample', name: 'cultureExample' },
    //                             { type: 'phrase', name: 'example', init:
    //                                 { fields: [
    //                                     { name: 'phrase', label: 'Example phrase', type: 'parts',
    //                                         parts: {
    //                                             koreanParts: [
    //                                                 { value: '돌아오는 이번주 금요일에 만', color: 'example' },
    //                                                 { value: '나요', color: 'pattern' },
    //                                             ],
    //                                             englishParts: [
    //                                                 { value: "Let's meet this coming Friday", color: 'english' },
    //                                             ],
    //                                         },
    //                                     },
    //                                 ] },
    //                             },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'CulturePatternInClip',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToActionText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Call to action text', value: 'Find the pattern in a song!', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'directionsText', name: 'directionsText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions text', value: "Let's look at the pattern as it appears in a popular song.", links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'cultureExample', name: 'cultureExample' },
    //                             { type: 'subTitledVideoClip', name: 'subTitledVideoClip' },
    //                         ] },
    //                     ],
    //                 },
    //             ],
    //         },
    //         { type: 'GoalCheck', init: { name: 'GoalCheck', modes: ['step', 'autoplay'], tags: '', notes: '' },
    //             pages: [
    //                 { type: 'GoalCheckIntro', init: { noLessonFrame: true, background: 'End', nextButton: 'none' },
    //                     steps: [
    //                         { elements: [
    //                             { type: 'completeGoalText', name: 'completeGoalText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Complete goal text', value: 'Now, let’s complete our goal!', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'startButton', name: 'startButton', init:
    //                                 { fields: [
    //                                     { name: 'label', type: 'text', label: 'Label', value: 'Final check', links: [], styles: [] },
    //                                 ] } },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'GoalCheckUnscramble', init: { background: 'Goal check' },
    //                     steps: [
    //                         { elements: [
    //                             { type: 'callToActionText', name: 'callToActionText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Call to action text', value: 'Check our goal!', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'directionsText', name: 'directionsText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions text', value: 'Use the words below to say this in Korean.', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'phraseSequence', name: 'phraseSequence' },
    //                         ] },
    //                     ],
    //                 },
    //                 { type: 'GoalCheckSuccess', init: { background: 'End', nextButton: 'none' },
    //                     steps: [
    //                         { elements: [
    //                             { type: 'congratsText', name: 'congratsText' },
    //                             { type: 'directionsText', name: 'directionsText', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Directions text', value: 'Good Job! You completed our goal!', links: [], styles: [] },
    //                                 ] } },
    //                             { type: 'stamp', name: 'stamp' },
    //                             { type: 'finishButton', name: 'finishButton' },
    //                         ] },
    //                     ],
    //                 },
    //             ],
    //         },
    //     ],
    // },

    // { type: 'Single-page lesson',
    //     init: { subtitle: '-- subtitle --', levelTitle: '1', tags: '', notes: '', listingLabel: '', pageSize: { width: 1200, height: 800 } },
    //     sections: [
    //         { type: 'Section', init: { name: 'Section', modes: ['step', 'autoplay'], tags: '', notes: '' },
    //             pages: [
    //                 { type: 'LessonPage',
    //                     steps: [
    //                         { elements: [
    //                             { type: 'text', name: 'text', init:
    //                                 { fields: [
    //                                     { name: 'text', type: 'text', label: 'Greetings', value: 'Hello, world!', links: [], styles: [] },
    //                                 ] } },
    //                         ] },
    //                     ],
    //                 },
    //             ],
    //         },
    //     ],
    // },
    //
    // //  Navigation card, maybe have a utilities 'lesson' to hold vrious kinds of ad-hoc pages
    // // this is  a special, hidden lesson that holds available pages that are not in any other lesson template
    // { type: 'Additional pages',
    //     init: { subtitle: '-- subtitle --', levelTitle: '1', tags: '', notes: '', listingLabel: '', pageSize: { width: 1200, height: 800 } },
    //     sections: [
    //     ],
    // },
];

// shared element library
export const elements = {

    layoutBox: { type: 'layoutBox', group: 'layout', size: '100%' },

    listButton: {
        type: 'listButton', group: 'navigation', size: '100%', init:
            { fields: [
                { name: 'label', type: 'text', label: 'Button label', value: 'Mini Lesson list', links: [], styles: [] },
                { name: 'destination', type: 'text', label: 'Jump to page', value: '-- page title --', links: [], styles: [] },
                { name: 'direction', type: 'choice', label: 'Expands', choices: ['Right', 'Left'], value: 'Right' },
            ] },
    },

    specialListButton: {
        type: 'specialListButton', group: 'navigation', size: '100%', init:
            { fields: [
                { name: 'label', type: 'text', label: 'Button label', value: 'Irregular Lesson list', links: [], styles: [] },
                { name: 'destination', type: 'text', label: 'Jump to page', value: '-- page title --', links: [], styles: [] },
                { name: 'direction', type: 'choice', label: 'Expands', choices: ['Right', 'Left'], value: 'Right' },
            ] },
    },

    processExampleButton: {
        type: 'processExampleButton', group: 'archived', size: '100%', init:
            { fields: [
                { name: 'processElementName', type: 'text', label: 'Pattern process element name', value: '', links: [], styles: [] },
                { name: 'example', label: 'Example', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '살아', color: 'example' },
                            { value: '요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'to live', color: 'english' },
                        ],
                    },
                },
            ] },
    },

    conversationAudio: {
        type: 'conversationAudio', group: 'archived', size: '100%', init:
            { fields: [
                { name: 'gender', type: 'choice', label: 'Gender', choices: ['Female', 'Male'], value: 'Female' },
                { name: 'sentence', label: 'Sentence', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '이 구두가', color: 'dark' },
                            { value: ' 마음에 들어요?', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'how do you like', color: 'englishBold' },
                            { value: ' these shoes?', color: 'english' },
                        ],
                    },
                },
            ] },
    },

    meaningAudioHint: {
        type: 'meaningAudioHint', group: 'archived', size: '100%', init:
            { fields: [
                { name: 'sentence', label: 'Sentence', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '이 구두가', color: 'idiomSentence' },
                            { value: ' 마음에 들어요?', color: 'idiomPattern' },
                        ],
                        englishParts: [
                            { value: '마음에 들어요', color: 'idiomLight' },
                            { value: ' these shoes?', color: 'english' },
                        ],
                    },
                },
            ] },
    },

    practiceReading: {
        type: 'practiceReading', group: 'Practice', exercise: true, size: '100%', init:
            { fields: [
                { name: 'correctAnswer', type: 'choice', label: 'Correct answer', choices: ['1', '2', '3', '4'], value: '1' },
                { name: 'gender', type: 'choice', label: 'Speaker gender', choices: ['Female', 'Male'], value: 'Female' },
                { name: 'target', label: 'Target', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '한국어 공부가 끝나면 뭘 하고 싶', color: 'target' },
                            { value: '어요?', color: 'pattern' },
                        ],
                    },
                },
                { name: 'answer1', label: 'Answer 1', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '친구와 밥을 먹으면서 이야기를 했어요.', color: 'dark' },
                        ],
                    },
                },
                { name: 'answer2', label: 'Answer 2', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '한국으로 유학을 갈까 해요.', color: 'dark' },
                        ],
                    },
                },
                { name: 'answer3', label: 'Answer 3', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '제가 마무리할 테니까 오늘은 일찍 가서 쉬세요.', color: 'dark' },
                        ],
                    },
                },
                { name: 'answer4', label: 'Answer 4', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '회사에 다니면서 한국어를 공부하고 있어요.', color: 'dark' },
                        ],
                    },
                },
            ] },
    },

    practiceListening: {
        type: 'practiceListening', group: 'Practice', exercise: true, size: '100%', init:
            { fields: [
                { name: 'correctAnswer', type: 'choice', label: 'Correct answer', choices: ['1', '2', '3', '4'], value: '1' },
                { name: 'gender', type: 'choice', label: 'Speaker gender', choices: ['Female', 'Male'], value: 'Female' },
                { name: 'target', label: 'Target', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '한국어 공부가 끝나면 뭘 하고 싶어요?', color: 'target' },
                        ],
                    },
                },
                { name: 'answer1', label: 'Answer 1', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '친구와 밥을 먹으면서 이야기를 했어요.', color: 'dark' },
                        ],
                    },
                },
                { name: 'answer2', label: 'Answer 2', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '한국으로 유학을 갈까 해요.', color: 'dark' },
                        ],
                    },
                },
                { name: 'answer3', label: 'Answer 3', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '제가 마무리할 테니까 오늘은 일찍 가서 쉬세요.', color: 'dark' },
                        ],
                    },
                },
                { name: 'answer4', label: 'Answer 4', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '회사에 다니면서 한국어를 공부하고 있어요.', color: 'dark' },
                        ],
                    },
                },
            ] },
    },

    practiceTyping: {
        type: 'practiceTyping', group: 'Practice', exercise: true, size: '100%', init:
            { // fieldEdits: ['commands'],
                fields: [
                { name: 'gender', type: 'choice', label: 'Speaker gender', choices: ['Female', 'Male'], value: 'Female' },
                { name: 'target', label: 'Challenge', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '주말마다 동네를 ', color: 'example' },
                            { value: '산책하곤 ', color: 'typeIn'},
                            { value: '니다.', color: 'typeIn' },
                        ],
                    },
                },
                { name: 'answer', label: 'Answer', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '주말마다 동네를.', color: 'example' },
                            { value: '산책', color: 'example' },
                            { value: '하곤 ', color: 'pattern' },
                            { value: '합.', color: 'pattern' },
                            { value: '니다.', color: 'example' },
                        ],
                        englishParts: [
                            { value: 'I often go for a walk around the neighborhood on weekends.', color: 'english' },
                        ],
                    },
                },
            ] },
    },


    advancedTyping: {
        type: 'advancedTyping', group: 'Practice', exercise: true, size: '100%', init:
            { // fieldEdits: ['commands'],
                fields: [
                { name: 'words', type: 'text', label: 'Words to use', value: '주말마다, 산책하다, -곤 하다', links: [], styles: [] },
                { name: 'english', type: 'text', label: 'English translation', value: 'I often go for a walk around the neighborhood on weekends.', links: [], styles: [] },
                { name: 'correctAnswer', label: 'Correct answer', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '주말마다 동네를 산책', color: 'example' },
                            { value: '하곤 합', color: 'pattern' },
                            { value: '니다.', color: 'example' },
                        ],
                    },
                },
            ] },
    },

    lessonCard: {
        type: 'lessonCard', group: 'navigation', size: '100%', init:
            { fields: [
                { name: 'lessonTitle', type: 'text', label: 'Lesson title', value: '', links: [], styles: [] },
            ] },
    },

    miniLessonCard: {
        type: 'miniLessonCard', group: 'navigation', size: '100%', init:
            { fields: [
                { name: 'title', type: 'text', label: 'Lesson title', value: '-르 irregular', links: [], styles: [] },
                { name: 'subtitle', type: 'text', label: 'Subtitle', value: 'Some 르 becomes ㄹㄹbefore -아요/-어요', links: [], styles: [] },
                { name: 'section', type: 'text', label: 'Mini-lesson section name', value: '', links: [], styles: [] },
                { name: 'icon', type: 'choice', label: 'Lesson icon', choices: ['None', 'ㅡ drops', 'ㅅ irregular', 'ㄹ irregular', 'ㅂ irregular', 'ㄷ irregular', 'ㅎ irregular'], value: 'None' },
            ] },
    },

    irregularLessonCard: {
        type: 'irregularLessonCard', group: 'navigation', size: '100%', init:
            { fields: [
                { name: 'title', type: 'text', label: 'Lesson title', value: '-르 irregular', links: [], styles: [] },
                { name: 'subtitle', type: 'text', label: 'Subtitle', value: 'Some 르 becomes ㄹㄹbefore -아요/-어요', links: [], styles: [] },
                { name: 'lesson', type: 'text', label: 'Lesson name', value: '', links: [], styles: [] },
                { name: 'icon', type: 'choice', label: 'Lesson icon', choices: ['None', 'ㅡ drops', 'ㅅ irregular', 'ㄹ irregular', 'ㅂ irregular', 'ㄷ irregular', 'ㅎ irregular'], value: 'None' },
            ] },
    },

    variantEntry: {
        type: 'variantEntry', group: 'navigation', size: '100%', managedByPage: true, init:
            { constraints: { horizontal: 'MIN', vertical: 'MIN' },
                fieldEdits: ['duplicate', 'move', 'delete', 'rename', 'hide'],
                fields: [
                    { name: 'condition', type: 'text', label: 'Condition/Meaning', value: 'insert condition or alternative meaning', links: [], styles: [] },
                    { name: 'variant', type: 'text', label: 'Variant pattern', value: '-아요', links: [], styles: [] },
                    { name: 'annotation', type: 'text', label: 'Annotation', value: '', links: [], styles: [] },
                    { name: 'example1', label: 'Example 1', type: 'parts',
                        parts: {
                            koreanParts: [
                                { value: '저는 서에 ', color: 'dark' },
                                { value: '살', color: 'example' },
                                { value: '아요', color: 'pattern' },
                            ],
                            englishParts: [
                                { value: 'I live in Seoul', color: 'english' },
                            ],
                        },
                    },
                    { name: 'example2', label: 'Example 2', type: 'parts',
                        parts: {
                            koreanParts: [
                                { value: '친구가 미국에서  ', color: 'dark' },
                                { value: '와요', color: 'pattern' },
                            ],
                            englishParts: [
                                { value: 'My friend is coming from the U.S.', color: 'english' },
                            ],
                        },
                    },
                    { name: 'example3', label: 'Example 3', type: 'parts',
                        parts: {
                            koreanParts: [
                                { value: '저는 바나나가 ', color: 'dark' },
                                { value: '좋', color: 'example' },
                                { value: '아요', color: 'pattern' },
                            ],
                            englishParts: [
                                { value: 'I like bananas', color: 'english' },
                            ],
                        },
                    },
                ],
            },
    },

    advancedVariantEntry: {
        type: 'advancedVariantEntry', group: 'navigation', size: '100%', managedByPage: true, init:
            { constraints: { horizontal: 'MIN', vertical: 'MIN' },
                fieldEdits: ['duplicate', 'move', 'delete', 'rename', 'hide'],
                fields: [
                    { name: 'variant', type: 'text', label: 'Variant pattern', value: '-기는요', links: [], styles: [] },
                    { name: 'condition', type: 'text', label: 'Condition/Meaning', value: 'insert condition or alternative meaning', links: [], styles: [] },
                    { name: 'annotation', type: 'text', label: 'Annotation', value: '', links: [], styles: [] },
                    { name: 'example1', label: 'Example 1', type: 'parts',
                        parts: {
                            koreanParts1: [
                                { value: '그 옷 잘 어울려요. 센스 있게 옷도 잘 입으시네요.', color: 'dark' },
                            ],
                            englishParts1: [
                                { value: 'You look great in that outfit, and you dress well.', color: 'english' },
                            ],
                            koreanParts2: [
                                { value: '잘 ', color: 'dark' },
                                { value: '입', color: 'example' },
                                { value: '기는요. ', color: 'pattern' },
                                { value: '매장에서 코디된 대로 사서 입는 거예요.', color: 'dark' },
                            ],
                            englishParts2: [
                                { value: 'Not really. I just buy coordinated outfits at the store.', color: 'english' },
                            ],
                            graphic: [
                                { url: '', mimeType: '' },
                            ],
                        },
                    },
                    { name: 'example2', label: 'Example 2', type: 'parts',
                        parts: {
                            koreanParts1: [
                                { value: '여행하', color: 'example' },
                                { value: '기는 ', color: 'pattern' },
                                { value: '좋아하지만, 요즘에는 시간이 없어서 잘 못 가요.', color: 'dark' },
                            ],
                            englishParts1: [
                                { value: 'I do like traveling, but these days I don\'t have the time, so I can\'t go often.', color: 'english' },
                            ],
                            koreanParts2: [
                                { value: '', color: 'dark' },
                            ],
                            englishParts2: [
                                { value: '', color: 'english' },
                            ],
                            graphic: [
                                { url: '', mimeType: '' },
                            ],
                        },
                        hiddenParts: ['koreanParts2', 'englishParts2'],
                    },
                ],
            },
    },

    miniLessonTableCard: {
        type: 'miniLessonTableCard', group: 'navigation', size: '100%', managedByPage: true, init:
            { constraints: { horizontal: 'MIN', vertical: 'MIN' },
                fields: [
                    { name: 'section', type: 'text', label: 'Mini-lesson section name', value: '', links: [], styles: [] },
                    { name: 'condition', type: 'text', label: 'Condition', value: 'Stem’s last vowel is ㅏ or ㅗ', links: [], styles: [] },
                    { name: 'variant', type: 'text', label: 'Variant pattern', value: '-아요', links: [], styles: [] },
                    { name: 'annotation', type: 'text', label: 'Annotation', value: '', links: [], styles: [] },
                    { name: 'example1', label: 'Example 1', type: 'parts',
                        parts: {
                            koreanParts: [
                                { value: '(살다) 살', color: 'dark' },
                                { value: '아요', color: 'pattern' },
                            ],
                        },
                    },
                    { name: 'example2', label: 'Example 2', type: 'parts',
                        parts: {
                            koreanParts: [
                                { value: '(오다) ', color: 'dark' },
                                { value: '와요', color: 'pattern' },
                            ],
                        },
                    },
                ],
            },
    },

    variantsTable: {
        type: 'variantsTable', group: 'navigation', size: '100%', init:
            { constraints: { horizontal: 'MIN', vertical: 'MIN' },
                fieldEdits: ['hide', 'noColor', 'noHide', 'noPartAdd'],
                fields: [
                    { name: 'headerLabel', type: 'text', label: 'Header label', value: 'Combines with:', links: [], styles: [] },
                    { name: 'headerText', type: 'text', label: 'Header text', value: 'Action verbs & Descriptive verbs', links: [], styles: [] },
                    { name: 'conditionRow', label: 'Condition label', type: 'parts',
                        parts: {
                            englishParts: [
                                { value: 'Condition' },
                            ],
                        },
                    },
                    { name: 'variantRow', label: 'Variants label', type: 'parts',
                        parts: {
                            englishParts: [
                                { value: 'Variants' },
                            ],
                        },
                    },
                    { name: 'meaningRow', label: 'Meanings label', type: 'parts', hidden: true,
                        parts: {
                            englishParts: [
                                { value: 'Meanings' },
                            ],
                        },
                    },
                    { name: 'examplesRow', label: 'Examples label', type: 'parts',
                        parts: {
                            englishParts: [
                                { value: 'Examples' },
                            ],
                        },
                    },
                ] },
    },

    advancedVariantsTable: {
        type: 'advancedVariantsTable', group: 'navigation', size: '100%', init:
            { constraints: { horizontal: 'MIN', vertical: 'MIN' },
                fieldEdits: ['hide', 'noColor', 'noHide', 'noPartAdd'],
                fields: [
                    { name: 'variantBox', label: 'Variants label', type: 'parts',
                        parts: {
                            englishParts: [
                                { value: 'Variant' },
                            ],
                        },
                    },
                    { name: 'conditionBox', label: 'Condition label', type: 'parts',
                        parts: {
                            englishParts: [
                                { value: 'Condition' },
                            ],
                        },
                    },
                ]
            },
    },

    miniLessonTable: {
        type: 'miniLessonTable', group: 'navigation', size: '100%', init:
            { constraints: { horizontal: 'MIN', vertical: 'MIN' },
                fields: [
                    { name: 'endcapLabel', type: 'text', label: 'End-cap label', value: 'Combines with:', links: [], styles: [] },
                    { name: 'endcapText', type: 'text', label: 'End-cap text', value: 'Action verbs & Descriptive verbs', links: [], styles: [] },
                ] },
    },

    patternSummary: {
        type: 'patternSummary', group: 'summary', size: '100%', init:
            { fields: [
                { name: 'title', type: 'text', label: 'Title', value: 'Pattern summary', links: [], styles: [] },
                { name: 'meaning', type: 'text', label: 'Meaning', value: 'Sounding polite but casual', links: [], styles: [] },
                { name: 'conditionsTitle', type: 'text', label: 'Conditions title', value: 'Action verbs & Descriptive Verbs', links: [], styles: [] },
                { name: 'conditions', type: 'text', label: 'Conditions', value: 'Stem’s last vowel is not ㅏ or ㅗ', links: [], styles: [] },
                { name: 'example1', label: 'Example 1', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '(살다) 살', color: 'dark' },
                            { value: '아요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'I live', color: 'english' },
                        ],
                    },
                },
                { name: 'example2', label: 'Example 2', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '(오다)', color: 'dark' },
                            { value: '와요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'I come', color: 'english' },
                        ],
                    },
                },
            ] },
    },

    summaryBox: {
        type: 'summaryBox', group: 'summary', size: '100%', init:
            { fields: [
                { name: 'title', type: 'text', label: 'Title', value: 'Pattern summary', links: [], styles: [] },
            ] },
    },

    summaryTextSection: { type: 'summaryTextSection', group: 'summary', size: '100%', init:
        { fields: [
            { name: 'sectionTitle', type: 'text', label: 'Section title', value: 'Meaning', links: [], styles: [] },
            { name: 'sectionText', type: 'text', label: 'Section text', value: 'Sounding polite but casual', links: [], styles: [] },
        ] },
    },

    summaryKoBulletsSection: { type: 'summaryKoBulletsSection', group: 'summary', size: '100%', init:
        { fields: [
            { name: 'sectionTitle', type: 'text', label: 'Section title', value: 'Combines with', links: [], styles: [] },
            { name: 'bullets', type: 'parts', label: 'Section items', hidden: false, collapsed: false,
                parts: {
                    koreanParts: [
                        { value: '(오다)', color: 'dark' },
                        { value: '와요', color: 'pattern' },
                    ],
                },
            },
        ] },
    },

    summaryEnBulletsSection: { type: 'summaryEnBulletsSection', group: 'summary', size: '100%', init:
        { fields: [
            { name: 'sectionTitle', type: 'text', label: 'Section title', value: 'Combines with', links: [], styles: [] },
            { name: 'bullets', type: 'parts', label: 'Section items', hidden: false, collapsed: false,
                parts: {
                    englishParts: [
                        { value: 'I live', color: 'english' },
                        { value: 'I live', color: 'english' },
                    ],
                },
            },
        ] },
    },

    summaryExamplesSection: { type: 'summaryExamplesSection', group: 'summary', size: '100%', init:
        { fields: [
            { name: 'sectionTitle', type: 'text', label: 'Section title', value: 'Examples', links: [], styles: [] },
            { name: 'example1', type: 'parts', label: 'Example 1', hidden: false, collapsed: false,
                parts: {
                    koreanParts: [
                        { value: '(살다) 살', color: 'dark' },
                        { value: '아요', color: 'pattern' },
                    ],
                    englishParts: [
                        { value: 'I live', color: 'english' },
                    ],
                },
            },
            { name: 'example2', type: 'parts', label: 'Example 2', hidden: false, collapsed: false,
                parts: {
                    koreanParts: [
                        { value: '(살다) 살', color: 'dark' },
                        { value: '아요', color: 'pattern' },
                    ],
                    englishParts: [
                        { value: 'I live', color: 'english' },
                    ],
                },
            },
        ] },
    },

    // patternSummary2: { type: 'patternSummary2', group: 'patterns', size: '100%', init:
    //     { fields: [
    //         { name: 'title', type: 'text', label: 'Title', value: 'Pattern summary', links: [], styles: [] },
    //         { name: 'box1Type', type: 'choice', label: 'Box 1 type', value: 'text', choices: ['text', 'English bullets', 'Korean examples'], links: [], styles: [] },
    //         { name: 'box1Title', type: 'text', label: 'Box 1 title', value: 'Meaning', links: [], styles: [] },
    //         { name: 'box1Text', type: 'text', label: 'Box 1 text', value: 'Sounding polite but casual', links: [], styles: [] },
    //         { name: 'box1Items', type: 'parts', label: 'Box 1 items', hidden: true, collapsed: true,
    //             parts: {
    //                 koreanParts: [
    //                     { value: '(살다) 살', color: 'dark', },
    //                     { value: '아요', color: 'pattern' },
    //                 ],
    //                 englishParts: [
    //                     { value: 'I live', color: 'english' },
    //                 ],
    //             },
    //         },
    //         { name: 'box2Type', type: 'choice', label: 'Box 2 type', value: 'Text', choices: ['Text', 'English bullets', 'Korean examples', 'Hidden'], links: [], styles: [] },
    //         { name: 'box2Title', type: 'text', label: 'Box 2 title', value: 'Action verbs & Descriptive Verbs', links: [], styles: [] },
    //         { name: 'box2Text', type: 'text', label: 'Box 2 text', value: 'Stem’s last vowel is not ㅏ or ㅗ', links: [], styles: [] },
    //         { name: 'box2Items', type: 'parts', label: 'Box 2 items', hidden: true, collapsed: true,
    //             parts: {
    //                 koreanParts: [
    //                     { value: '(살다) 살', color: 'dark', },
    //                     { value: '아요', color: 'pattern' },
    //                 ],
    //                 englishParts: [
    //                     { value: 'I live', color: 'english' },
    //                 ],
    //             },
    //         },
    //         { name: 'box3Type', type: 'choice', label: 'Box 3 type', value: 'Korean examples', choices: ['Text', 'English bullets', 'Korean examples', 'Hidden'], links: [], styles: [] },
    //         { name: 'box3Title', type: 'text', label: 'Box 3 title', value: 'Meaning', links: [], styles: [] },
    //         { name: 'box3Text', type: 'text', label: 'Box 3 text', value: 'Sounding polite but casual', links: [], styles: [] },
    //         { name: 'box3Items1', type: 'parts', label: 'Box 3 item1', hidden: true, collapsed: true,
    //             parts: {
    //                 koreanParts: [
    //                     { value: '(살다) 살', color: 'dark', },
    //                     { value: '아요', color: 'pattern' },
    //                 ],
    //                 englishParts: [
    //                     { value: 'I live', color: 'english' },
    //                 ],
    //             },
    //         },
    //         { name: 'box4Type', type: 'choice', label: 'Box 4 type', value: 'Hidden', choices: ['Text', 'English bullets', 'Korean examples', 'Hidden'], links: [], styles: [] },
    //         { name: 'box4Title', type: 'text', label: 'Box 4 title', value: 'Meaning', links: [], styles: [] },
    //         { name: 'box4Text', type: 'text', label: 'Box 4 text', value: 'Sounding polite but casual', links: [], styles: [] },
    //         { name: 'box4Items', type: 'parts', label: 'Box 4 items', hidden: true, collapsed: true,
    //             parts: {
    //                 koreanParts: [
    //                     { value: '(살다) 살', color: 'dark', },
    //                     { value: '아요', color: 'pattern' },
    //                 ],
    //                 englishParts: [
    //                     { value: 'I live', color: 'english' },
    //                 ],
    //             },
    //         },
    //     ]}
    // },

    patternVariantsSummary: {
        type: 'patternVariantsSummary', group: 'summary', size: '100%', init:
            { fields: [
                { name: 'title', type: 'text', label: 'Title', value: 'Pattern summary', links: [], styles: [] },
                { name: 'meaning', type: 'text', label: 'Meaning', value: 'Sounding polite but casual', links: [], styles: [] },
                { name: 'combinesWith', label: 'Combines with', type: 'parts',
                    parts: {
                        englishParts: [
                            { value: 'Action verbs', color: 'dark' },
                            { value: 'Descriptive verbs', color: 'dark' },
                        ],
                    },
                },
                { name: 'followedBy', label: 'Followed by', type: 'parts', hidden: true, collapsed: true,
                    parts: {
                        englishParts: [
                            { value: 'Nouns', color: 'dark' },
                        ],
                    },
                },
                { name: 'variants', label: 'Variants', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '-아요', color: 'dark' },
                            { value: '-어요', color: 'dark' },
                            { value: '-여요', color: 'dark' },
                        ],
                    },
                },
            ] },
    },

    miniTest: { type: 'miniTest', group: 'graphics', size: '100%', init:
        { fields: [] } },

    vocabIntro: { type: 'vocabIntro', group: 'graphics', size: '100%', init: 
        { fields: [] } },

    lessonIntro: { type: 'lessonIntro', group: 'graphics', size: '100%', init: 
        { fields: [] } },

    practiceIntro: { type: 'practiceIntro', group: 'graphics', size: '100%', init: 
        { fields: [] } },

    cultureIntro: { type: 'cultureIntro', group: 'graphics', size: '100%', init: 
        { fields: [] } },

    idiomIntro: { type: 'idiomIntro', group: 'graphics', size: '100%', init: 
        { fields: [] } },

    cultureExample: { type: 'cultureExample', group: 'examples', size: '100%', init: 
        { fields: [
            { name: 'mediaType', type: 'choice', label: 'Media type', choices: ['Song', 'Film & Video'], value: 'Song' },
            { name: 'prefix', type: 'text', label: 'Prefix', value: 'Friday', links: [], styles: [] },
            { name: 'example', type: 'text', label: 'Button text', value: '금요일에 만나요', links: [], styles: [] },
            { name: 'postfix', type: 'text', label: 'Postfix', value: 'by IU', links: [], styles: [] },
            { name: 'explanation', type: 'text', label: 'Explanation', value: "‘금요일에 만나요' is a love song by IU. It is an acoustic pop song with an easy medium tempo melody that you can hum once you listen to it.", links: [], styles: [] },
        ] } },

    // this single graphic represents the full functional completion graphic.
    // todo(budleigh) - clarify behavior w/designers
    completionStars: { type: 'completionStars', group: 'graphics', size: '100%', init: 
        { fields: [] } },

    miniTestParty: { type: 'miniTestParty', group: 'graphics', size: '100%', init: 
        { fields: [] } },

    lessonDone: { type: 'lessonDone', group: 'graphics', size: '100%', init: 
        { fields: [] } },

    irregularLessonDone: { type: 'irregularLessonDone', group: 'graphics', size: '100%', init: 
        { fields: [] } },

    miniLessonDone: { type: 'miniLessonDone', group: 'graphics', size: '100%', init: 
        { fields: [] } },

    'ㅅ irregular': { type: 'ㅅ irregular', group: 'graphics', size: '100%', init:
        { fields: [] } },
    'ㅡ drops': { type: 'ㅡ drops', group: 'graphics', size: '100%', init:
        { fields: [] } },
    'ㄹ irregular': { type: 'ㄹ irregular', group: 'graphics', size: '100%', init:
        { fields: [] } },
    'ㅂ irregular': { type: 'ㅂ irregular', group: 'graphics', size: '100%', init:
        { fields: [] } },
    'ㄷ irregular': { type: 'ㄷ irregular', group: 'graphics', size: '100%', init:
        { fields: [] } },
    'ㅎ irregular': { type: 'ㅎ irregular', group: 'graphics', size: '100%', init:
        { fields: [] } },

    'irregularIcon': { type: 'irregularIcon', group: 'graphics', size: '100%', init:
        { fields: [
            { name: 'icon', type: 'choice', label: 'Icon choice', choices: ['None', 'ㅡ drops', 'ㅅ irregular', 'ㄹ irregular', 'ㅂ irregular', 'ㄷ irregular', 'ㅎ irregular'], value: 'None' },
        ] } },

    stamp: { type: 'stamp', group: 'graphics', size: '100%', init:
        { fields: [] } },

    hangul: { type: 'hangul', group: 'graphics', size: '100%', init:
        { fields: [] } },

    pickOne: { type: 'pickOne', group: 'practice', exercise: true, size: '100%', init:
        { fields: [
            { name: 'target', label: 'Target word', type: 'parts',
                parts: {
                    koreanParts: [
                        { value: '마시', color: 'example' },
                        { value: '다', color: '다' },
                    ],
                    englishParts: [
                        { value: 'to drink', color: 'english' },
                    ],
                },
            },
            { name: 'button1', label: 'Button 1', type: 'parts',
                parts: {
                    koreanParts: [
                        { value: '-어요', color: 'black' },
                    ],
                },
            },
            { name: 'button2', label: 'Button 2', type: 'parts',
                parts: {
                    koreanParts: [
                        { value: '-아요', color: 'black' },
                    ],
                },
            },
            { name: 'button3', label: 'Button 3', type: 'parts',
                parts: {
                    koreanParts: [
                        { value: '-여요', color: 'black' },
                    ],
                },
            },
            { name: 'correctAnswer', type: 'choice', label: 'Correct answer', choices: ['Button 1', 'Button 2', 'Button 3'], value: 'Button 1' },
            { name: 'finalForm', label: 'Final form', type: 'parts', 
                parts: {
                    koreanParts: [
                        { value: '마셔', color: 'example' },
                        { value: '요', color: 'pattern' },
                    ],
                    englishParts: [
                        { value: '(I) drink', color: 'english' },
                    ],
                },
            },
        ] },
    },

    pickALetter: { type: 'pickALetter', group: 'practice', exercise: true, size: '100%', init:
        { fields: [
            { name: 'type', type: 'choice', label: 'Quiz type', choices: ['Pick by reading', 'Pick by listening'], value: 'Pick by reading' },
            { name: 'target', label: 'Target letter', type: 'text', value: 'ㅏ' },
            { name: 'button1', label: 'Button 1', type: 'text', value: 'a' },
            { name: 'button2', label: 'Button 2', type: 'text', value: 'o' },
            { name: 'button3', label: 'Button 3', type: 'text', value: 'eo' },
            { name: 'button4', label: 'Button 4', type: 'text', value: 'u' },
            { name: 'correctAnswer', type: 'choice', label: 'Correct choice', choices: ['Button 1', 'Button 2', 'Button 3', 'Button 4'], value: 'Button 1' },
            { name: 'voicing', type: 'choice', label: 'Voicing', choices: ['Male slow', 'Male normal', 'Male fast', 'Female slow', 'Female normal', 'Female fast'], value: 'Male slow' },
        ] },
    },

    drag: { type: 'drag', group: 'practice', exercise: true, size: '100%', init:
        { fields: [
            { name: 'particle', label: 'Particle', type: 'text', value: '이' },
            { name: 'left', label: 'Left', type: 'text', value: '꽃' },
            { name: 'right', label: 'Right', type: 'text', value:  '예뻐요' },
            { name: 'correctDirection', type: 'choice', label: 'Correct direction', value: 'left', choices: ['left', 'right'] },
            { name: 'finalForm', label: 'Final form', type: 'parts', 
                parts: {
                    koreanParts: [
                        { value: '꽃', color: 'example' },
                        { value: '이', color: 'pattern' },
                        { value: ' ', color: 'space' },
                        { value: ' 예뻐요.', color: 'example' },
                    ],
                    englishParts: [
                        { value: 'The flowers are pretty', color: 'english' },
                    ],
                },
            },
        ] },
    },

    phraseBoard: { type: 'phraseBoard', group: 'practice', exercise: true, size: '100%', init:
        { fields: [
            { name: 'table', label: 'Phrase board entries', type: 'phraseBoard', size: '4x4',
                parts: {
                    rows: [
                        { cell0: '마', cell1: '화', cell2: '영', cell3: '기' },
                        { cell0: '음', cell1: '라', cell2: '는', cell3: '드' },
                        { cell0: '좋', cell1: '아', cell2: '하', cell3: '다' },
                        { cell0: '음', cell1: '악', cell2: '사', cell3: '랑' },
                    ],
                },
            },
            { name: 'correctAnswer', type: 'text', label: 'Correct answer', value: '좋아하는 영화' },
            { name: 'path', type: 'text', label: 'Path (row,col),(row,col)...', value: '(2,0),(2,1),(2,2),(1,2)' },
            { name: 'english', label: 'Answer translation', type: 'text', value: 'movies that I like' },
            { name: 'fillInTheBlanks', type: 'text', label: 'Fill-in-the-blanks', value: '좋___ 영화' },
        ] },
    },

    // completeThePhrase: { type: 'completeThePhrase', group: 'practice', exercise: true, size: '100%', init:
    //     { fields: [
    //         { name: 'englishSentence', type: 'text', label: 'Translation', value: 'The person I met today', styles: [] },
    //         { name: 'style', type: 'choice', label: 'Quiz style', value: 'Complete the phrase', choices: ['Complete the phrase', 'Unscramble', 'Goal check'] },
    //         { name: 'form', type: 'choice', label: 'Button form', value: 'Ko or En', choices: ['Ko + En', 'Ko or En'] },
    //         { name: 'sentenceToComplete', label: 'Sentence to complete', type: 'pattern', arrows: false, topOnly: true,
    //             newPart: { color: 'black', top: '-word-' },
    //             parts: {
    //                 words: [
    //                     { color: 'black', top: '오늘', hidden: true },
    //                     { color: 'space', top: ' ' },
    //                     { color: 'black', top: '만나', hidden: true },
    //                     { color: 'black', top: '는', hidden: true },
    //                     { color: 'space', top: ' ' },
    //                     { color: 'black', top: '사람', hidden: false },
    //                 ],
    //             },
    //         },
    //         { name: 'wordsToPick', label: 'Words to pick', type: 'pattern', arrows: false, topOnly: true,
    //             newPart: { color: 'black', top: '-word-' },
    //             parts: {
    //                 words: [
    //                     { color: 'black', top: '만나' },
    //                     { color: 'black', top: '은' },
    //                     { color: 'black', top: '오늘' },
    //                     { color: 'black', top: '어제' },
    //                     { color: 'black', top: '는' },
    //                     { color: 'black', top: '들' },
    //                 ],
    //             },
    //         },
    //     ] },
    // },

    phraseSequence: { type: 'phraseSequence', group: 'practice', exercise: true, size: '100%', init:
        { fields: [
            { name: 'english', label: 'English translation', type: 'text', value: 'The person that I met today' },
            { name: 'style', type: 'choice', label: 'Quiz style', value: 'Complete the phrase', choices: ['Complete the phrase', 'Unscramble', 'Goal check'] },
            { name: 'steps', label: 'Phrase building steps', type: 'list',
                listFields: [
                    { label: 'Step', name: 'step', type: 'text' },
                    { label: 'Choice', name: 'choice', type: 'text' },
                ],
                listItems: [
                    { step: '__ 만나_ 사람', choice: '오늘' },
                    { step: '오늘 만나_ 사람', choice: '는' },
                    { step: '오늘 만나는 사람', choice: '' },
                ],
            },
            { name: 'otherChoices', label: 'Additional choices', type: 'list',
                listFields: [
                    { label: 'Fragment', name: 'fragment', type: 'text' },
                ],
                listItems: [
                    { fragment: '오' },
                    { fragment: '들' },
                    { fragment: '어제' },
                ],
            },
        ] },
    },

    makeTheWord: { type: 'makeTheWord', group: 'practice', exercise: true, size: '100%', init:
        { fields: [
            { name: 'style', type: 'choice', label: 'Quiz style', value: 'Make the word', choices: ['Make the word'], hidden: true },
            { name: 'steps', label: 'Phrase building steps', type: 'list',
                listFields: [
                    { label: 'Step', name: 'step', type: 'text' },
                    { label: 'Choice', name: 'choice', type: 'text' },
                ],
                listItems: [
                    { step: '__', choice: '여' },
                    { step: '여_', choice: '우' },
                    { step: '여우', choice: '' },
                ],
            },
            { name: 'otherChoices', label: 'Additional choices', type: 'list',
                listFields: [
                    { label: 'Fragment', name: 'fragment', type: 'text' },
                ],
                listItems: [
                    { fragment: '오' },
                    { fragment: '으' },
                    { fragment: '야' },
                    { fragment: '요' },
                ],
            },
            { name: 'word', type: 'text', label: 'Korean word', value: '여우', links: [], styles: [] },
            { name: 'graphic', type: 'graphic', label: 'Graphic', url: '', mimeType: ''},
            { name: 'scale', type: 'text', label: 'Graphic scale', value: '1.0', links: [], styles: [] },
            { name: 'voicing', type: 'choice', label: 'Voicing', choices: ['Male slow', 'Male normal', 'Male fast', 'Female slow', 'Female normal', 'Female fast'], value: 'Male slow' },
        ] },
    },

    videoClip: { type: 'videoClip', group: 'media', size: '100%', init:
        { fields: [
            { name: 'url', type: 'text', label: 'URL', value: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ' },
            { name: 'startHour', type: 'text', label: 'Start at hour', value: '0' },
            { name: 'startMinute', type: 'text', label: 'Start at minute', value: '0' },
            { name: 'startSecond', type: 'text', label: 'Start at second', value: '0' },
            { name: 'length', type: 'text', label: 'Clip length (seconds)', value: '15' },
        ] } },

    image: { type: 'image', group: 'media', size: '100%', init:
        { fields: [
            { name: 'url', type: 'text', label: 'URL', value: 'https://images.unsplash.com/photo-1618174168866-c66b9d68e983?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1335&q=80' },
        ] } },

    subTitledVideoClip: { type: 'subTitledVideoClip', group: 'media', size: '100%', init:
        { fields: [
            { name: 'url', type: 'text', label: 'URL', value: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ' },
            { name: 'startHour', type: 'text', label: 'Start at hour', value: '0' },
            { name: 'startMinute', type: 'text', label: 'Start at minute', value: '0' },
            { name: 'startSecond', type: 'text', label: 'Start at second', value: '0' },
            { name: 'length', type: 'text', label: 'Clip length (seconds)', value: '15' },
            { name: 'subtitle', label: 'Subtitle', type: 'parts',
                style: { koreanFontSize: '22px', englishFontSize: '15px' },
                mobile: { style: { koreanFontSize: '20px', englishFontSize: '14px' } },
                parts: {
                    koreanParts: [
                        { value: '돌아오는 이번주 금요일에 만', color: 'dark' },
                        { value: '나요.', color: 'pattern' },
                    ],
                    englishParts: [
                        { value: "Let's meet this...", color: 'english' },
                    ],
                },
            },
        ] } },

    goalTitle: { type: 'goalTitle', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Text', value: 'Lesson goal', links: [], styles: [] },
        ] } },


    goalText: { type: 'goalText', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Text', value: '', links: [], styles: [] },
        ] } },

    goodJobText: { type: 'goodJobText', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Text', value: 'Excellent!', links: [], styles: [] },
        ] } },

    congratsText: { type: 'congratsText', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Text', value: 'Congratulations!', links: [], styles: [] },
        ] } },

    irregularCongratsText: { type: 'irregularCongratsText', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Text', value: 'Awesome!', links: [], styles: [] },
        ] } },

    completeGoalText: { type: 'completeGoalText', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Text', value: 'Now, let’s complete our goal!', links: [], styles: [] },
        ] } },

    // a representative sentence form. used as a placeholder for selectable example pattern-animations, rendered by the patternAnimation component
    sentenceForm:  { type: 'sentenceForm', group: 'patterns', size: '100%', exercise: true, init:
        { fields: [
            { name: 'sentence', label: 'Sentence form', hidden: false, type: 'parts', states: ['form'],
                parts: {
                    koreanParts: [
                        { value: '(noun)', color: 'dark' },
                        { value: '>|<', color: 'merge' },
                        { value: '이/가', color: 'example' },
                        { value: '<|>', color: 'separate' },
                        { value: '마음에 들', color: 'pattern' },
                        { value: '>|<', color: 'merge' },
                        { value: '다', color: '다' },
                    ],
                    englishParts: [
                        { value: '>|<', color: 'merge' },
                        { value: '<|>', color: 'separate' },
                        { value: '>|<', color: 'merge' },
                    ],
                    narration: [
                        { value: 'Replace the NOUN with anything or anyone that captures your heart!', styles: [], links: [] },
                    ],
                },
            },
        ] },
    },
    
    sentenceFormExample:  { type: 'sentenceFormExample', group: 'patterns', size: '100%', exercise: true, init:
        { fieldEdits: ['duplicate', 'move', 'delete', 'rename', 'hide', 'searchAndReplace'],
            fields: [
                {
                    name: 'Example',
                    label: 'Example',
                    hidden: true,
                    type: 'parts',
                    states: ['Example'],
                    parts: {
                        koreanParts: [
                            { value: '매뉴', color: 'example' },
                            { value: '>|<', color: 'merge' },
                            { value: '<|>', color: 'separate' },
                            { value: '>|<', color: 'merge' },
                        ],
                        englishParts: [
                            { value: 'menu', color: 'english' },
                            { value: '>|<', color: 'merge' },
                            { value: '<|>', color: 'separate' },
                            { value: '>|<', color: 'merge' },
                        ],
                        narration: [{ value: '', styles: [], links: [] }],
                    },
                    collapsed: false,
                    hiddenParts: ['narration'],
                },
                {
                    name: 'Sentence form',
                    label: 'Sentence form',
                    hidden: false,
                    type: 'parts',
                    states: ['Sentence form'],
                    parts: {
                        koreanParts: [
                            { value: '(noun)', color: 'dark' },
                            { value: '>|<', color: 'merge' },
                            { value: '이/가', color: 'example' },
                            { value: '<|>', color: 'separate' },
                            { value: '마음에 들', color: 'pattern' },
                            { value: '>|<', color: 'merge' },
                            { value: '다', color: '다' },
                        ],
                        englishParts: [{ value: '>|<', color: 'merge' }, { value: '<|>', color: 'separate' }, { value: '>|<', color: 'merge' }],
                        narration: [{ value: 'Replace the NOUN with anything or anyone that captures your heart!', styles: [], links: [] }],
                    },
                    collapsed: true,
                },
                {
                    name: 'Pick a noun',
                    label: 'Pick a noun',
                    hidden: false,
                    type: 'parts',
                    states: ['Pick a noun'],
                    parts: {
                        koreanParts: [
                            { value: '매뉴', color: 'example' },
                            { value: '>|<', color: 'merge' },
                            { value: '가', color: 'example' },
                            { value: '<|>', color: 'separate' },
                            { value: '마음에 들', color: 'pattern' },
                            { value: '>|<', color: 'merge' },
                            { value: '다', color: '다' },
                        ],
                        englishParts: [
                            { value: 'menu', color: 'english' },
                            { value: '>|<', color: 'merge' },
                            { value: '<|>', color: 'separate' },
                            { value: '>|<', color: 'merge' },
                        ],
                        narration: [
                            {
                                value: "In this case, let's use the noun 매뉴 (menu).  Since it ends in a vowel, we pick 가 to mark it as the subject of the sentence.",
                                styles: [],
                                links: [],
                            },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Remove 다',
                    label: 'Remove 다',
                    hidden: false,
                    type: 'parts',
                    states: ['Remove 다'],
                    parts: {
                        koreanParts: [
                            { value: '매뉴', color: 'example' },
                            { value: '>|<', color: 'merge' },
                            { value: '가', color: 'example' },
                            { value: '<|>', color: 'separate' },
                            { value: '마음에 들', color: 'pattern' },
                            { value: '>|<', color: 'merge' },
                            { value: '다', color: '다', command: 'remove' },
                        ],
                        englishParts: [
                            { value: 'menu', color: 'english' },
                            { value: '>|<', color: 'merge' },
                            { value: '<|>', color: 'separate' },
                            { value: '>|<', color: 'merge' },
                        ],
                        narration: [
                            {
                                value: "Let's conjugate this into an informal sentence, say between close friends, by first removing the 다 ending...",
                                styles: [],
                                links: [],
                            },
                            {
                                value: 'and then selecting the informal ending 어, since the final verb 들 does not end in 아  or 오...',
                                styles: [],
                                links: [],
                            },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Conjugate',
                    label: 'Conjugate',
                    hidden: false,
                    type: 'parts',
                    states: ['Conjugate'],
                    parts: {
                        koreanParts: [
                            { value: '매뉴', color: 'example' },
                            { value: '>|<', color: 'merge' },
                            { value: '가', color: 'example' },
                            { value: ' ', color: 'space' },
                            { value: '>|<', color: 'merge' },
                            { value: '마음에 들', color: 'pattern' },
                            { value: '>|<', color: 'merge' },
                            { value: '어', color: '다', command: 'flyIn=130' },
                        ],
                        englishParts: [
                            { value: 'I like the menu', color: 'english' },
                            { value: '>|<', color: 'merge' },
                            { value: '>|<', color: 'merge' },
                            { value: '>|<', color: 'merge' },
                        ],
                        narration: [{ value: '+Giving the final meaning "I Like the menu", spoken casually', styles: [], links: [] }],
                    },
                    collapsed: true,
                },
            ] },
    },

    // pattern application variants
    patternAnimation:  { type: 'patternAnimation', group: 'patterns', size: '100%', exercise: true, init:
        { fieldEdits: ['duplicate', 'move', 'delete', 'rename', 'hide', 'searchAndReplace'],
            fields: [
                { name: 'layout', type: 'choice', label: 'Layout', choices: ['Horizontal', 'Vertical', 'Single row'], value: 'Horizontal' },
                { name: 'example', label: 'Example button', hidden: true, type: 'parts', states: [],
                    parts: {
                        koreanParts: [
                            { value: '마시다', color: 'example' },
                        ],
                        englishParts: [
                            { value: 'to drink', color: 'english' },
                        ],
                    },
				    collapsed: true,
                },
                {
                    name: 'pattern', label: 'Pattern', hidden: false, type: 'parts', states: ['pattern'],
                    parts: {
                        koreanParts: [
                            { value: '<|>', color: 'separate' },
                            { value: '-어요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: '<|>', color: 'separate' },
                            { value: 'polite style ending', color: 'patternSubtitle' },
                        ],
                        narration: [
                            { value: 'Let’s have a closer look...', styles: [], links: [] },
                            { value: '-어요 forms a polite informal sentence ', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
            ],
        },
    },

    introductoryVerbConjugation:  { type: 'introductoryVerbConjugation', group: 'patterns', size: '100%', exercise: true, init:
        { fieldEdits: ['duplicate', 'move', 'delete', 'rename', 'hide', 'searchAndReplace'],
            fields: [
                { name: 'layout', type: 'choice', label: 'Layout', choices: ['Horizontal', 'Vertical', 'Single row'], value: 'Horizontal' },
                {
                    name: 'Pattern', label: 'Pattern', type: 'parts', states: ['pattern'],
                    parts: {
                        koreanParts: [
                            { value: '<|>', color: 'separate' },
                            { value: '-어요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: '<|>', color: 'separate' },
                            { value: 'polite style ending', color: 'patternSubtitle' },
                        ],
                        narration: [
                            { value: 'Let’s have a closer look...', styles: [], links: [] },
                            { value: '-어요 forms a polite informal sentence ', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Applied general form', label: 'Applied general form', type: 'parts', states: ['appliedForm'],
                    parts: {
                        koreanParts: [
                            { value: 'VERB', color: 'example', command: 'separate' },
                            { value: '<|>', color: 'separate' },
                            { value: '-어요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: '<|>', color: 'separate' },
                            { value: 'polite style ending', color: 'patternSubtitle' },
                        ],
                        narration: [
                            { value: '+It is always attached to the final verb.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Verb', label: 'Verb', type: 'parts',
                    hidden: false, states: ['verb'],
                    parts: {
                        koreanParts: [
                            { value: '마시', color: 'example' },
                            { value: '다', color: '다' },
                            { value: '<|>', color: 'separate' },
                            { value: '-어요 ', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'to drink', color: 'english' },
                            { value: '<|>', color: 'separate' },
                            { value: 'polite style ending', color: 'patternSubtitle' },
                        ],
                        narration: [
                            { value: 'Let’s choose a verb, in this case 마시다 (to drink)', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Stem the verb', label: 'Stem the verb', type: 'parts', states: ['partGoes'],
                    parts: {
                        koreanParts: [
                            { value: '마시', color: 'example' },
                            { value: '다', color: '다', command: 'remove' },
                            { value: '<|>', color: 'separate' },
                            { value: '-어요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'to drink', color: 'english' },
                            { value: '_', color: 'separate' },
                            { value: 'polite style ending', color: 'patternSubtitle' },
                        ],
                        narration: [
                            { value: 'In Korean, only the verb stem stays when an ending follows, so the 다 goes away.', styles: [], links: [
                                { start: 25, end: 29, linkText: 'stem', ref: 'Aside/Stem' },
                            ] },
                            { value: '마시 is the stem, which stays and contains the core meaning of the verb.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Inspect', label: 'Inspect', type: 'parts', states: ['inspect'],
                    parts: {
                        koreanParts: [
                            { value: '마', color: 'example', command: 'noFade' },
                            { value: '시', color: 'example', command: 'inspect=ㅣ,delay' },
                            { value: '<|>', color: 'separate' },
                            { value: '-어요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'to drink', color: 'english' },
                            { value: '<|>', color: 'separate' },
                            { value: 'polite style ending', color: 'patternSubtitle' },
                        ],
                        narration: [
                            { value: 'We select the appropriate variant by checking the final vowel.', styles: [], links: [] },
                            { value: 'In this case, the vowel is ㅣ, not 아 or 오, so ...', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Select pattern', label: 'Select pattern', type: 'parts', states: ['select'],
                    parts: {
                        koreanParts: [
                            { value: '마시', color: 'example' },
                            { value: '>|<', color: 'merge' },
                            { value: '어요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'I drink', color: 'english' },
                            { value: '>|<', color: 'merge' },
                        ],
                        narration: [
                            { value: 'We select the 어요 ending.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Check for abbreviation', label: 'Check for abbreviation', type: 'parts', states: ['checkAbbreviation'],
                    parts: {
                        koreanParts: [
                            { value: '마', color: 'example' },
                            { value: '시', color: 'example', command: 'check2' },
                            { value: '>|<', color: 'merge' },
                            { value: '어', color: 'pattern' },
                            { value: '요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'I drink', color: 'english' },
                            { value: '>|<', color: 'merge' },
                        ],
                        narration: [
                            { value: 'The 시 and 어 combine into 셔 for ease of pronunciation.', styles: [
                                { start: 4, end: 5, styledText: '시', style: 'highlight' },
                                { start: 10, end: 11, styledText: '어', style: 'highlight' },
                                { start: 25, end: 26, styledText: '셔', style: 'highlight' },
                            ], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Abbreviation', label: 'Abbreviation', type: 'parts', states: ['abbreviate'],
                    parts: {
                        koreanParts: [
                            { value: '마', color: 'example' },
                            { value: '셔', color: 'example' },
                            { value: '>|<', color: 'merge' },
                            { value: '요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'I drink', color: 'english' },
                            { value: '>|<', color: 'merge' },
                        ],
                        narration: [
                            { value: 'Now we have a polite informal sentence.', styles: [], links: [] },
                            { value: 'As the subject is not specified, we are not sure who is drinking.  This short sentence can be used as a polite suggestion or command - “Please drink.” or “Let’s drink."', styles: [], links: [] },
                            { value: 'You may add more to this phrase, such as a subject who drinks or an object to drink.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Final sections', label: 'Final sections', type: 'parts', states: ['finalSections'],
                    parts: {
                        koreanParts: [
                            { value: '마셔', color: 'example' },
                            { value: '>|<', color: 'merge' },
                            { value: '어요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'I drink', color: 'english' },
                            { value: '>|<', color: 'merge' },
                        ],
                        narration: [
                            { value: 'We are now ready to form the final phrase.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'Final phrase', label: 'Final phrase', type: 'parts', states: ['final'],
                    parts: {
                        koreanParts: [
                            { value: '마셔', color: 'example', command: 'merge' },
                            { value: '>|<', color: 'merge' },
                            { value: '요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'I drink', color: 'english' },
                            { value: '>|<', color: 'merge' },
                        ],
                        narration: [
                            { value: 'Now we have a polite informal sentence.', styles: [], links: [] },
                            { value: 'As the subject is not specified, we are not sure who is eating.  This short sentence can be used as a polite suggestion or command - “Please eat.” or “Let’s eat.”', styles: [], links: [] },
                            { value: 'You may add more to this phrase, such as a subject who eats or an object to be eaten.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
            ],
        },
    },

    verbConjugation:  { type: 'verbConjugation', group: 'patterns', size: '100%', exercise: true, init:
        { fieldEdits: ['duplicate', 'move', 'delete', 'rename', 'hide', 'searchAndReplace'],
            fields: [
                { name: 'layout', type: 'choice', label: 'Layout', choices: ['Horizontal', 'Vertical', 'Single row'], value: 'Horizontal' },
                { name: 'example', label: 'Example', type: 'parts', states: [], hidden: true, collapsed: true,
                    parts: {
                        koreanParts: [
                            { value: '마시다', color: 'example' },
                        ],
                        englishParts: [
                            { value: 'to drink', color: 'english' },
                        ],
                    },
                },
                { name: 'Verb', label: 'Verb', type: 'parts', hidden: false, states: ['verb'], collapsed: true, parts: {
                    koreanParts: [
                        { value: '마시', color: 'example' },
                        { value: '다', color: '다' },
                        { value: '<|>', color: 'separate' },
                    ],
                    englishParts: [
                        { value: 'to drink', color: 'english' },
                        { value: '<|>', color: 'separate' },
                    ],
                    narration: [
                        { value: "The verb we'll use is for this example is 마시다 (to drink)", styles: [], links: [] },
                    ],
                },
                },
                { name: 'Stem the verb', label: 'Stem the verb', type: 'parts', states: ['partGoes'], collapsed: true,
                    parts: {
                        koreanParts: [
                            { value: '마시', color: 'example' },
                            { value: '다', color: '다', command: 'remove' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to drink', color: 'english' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'In Korean, only the verb stem stays when an ending follows, so the 다 goes away.', styles: [],
                                links: [{ start: 25, end: 29, linkText: 'stem', ref: 'Aside/Stem' }] },
                            { value: '마시 is the stem, which stays and contains the core meaning of the verb.', styles: [], links: [] },
                        ],
                    },
                },
                { name: 'Inspect', label: 'Inspect', type: 'parts', states: ['inspect'], collapsed: true,
                    parts: {
                        koreanParts: [
                            { value: '마', color: 'example', command: 'noFade' },
                            { value: '시', color: 'example', command: 'inspect=ㅣ,delay' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to drink', color: 'english', command: '' },
                        ],
                        narration: [
                            { value: 'To select the correct variant, we check the final vowel.', styles: [], links: [] },
                            { value: 'In this case, the vowel is ㅣ, not 아 or 오, so ...', styles: [], links: [] },
                        ],
                    },
                },
                { name: 'Select pattern', label: 'Select pattern', type: 'parts', states: ['select'], collapsed: true, parts: {
                    koreanParts: [
                        { value: '마시', color: 'example' },
                        { value: '>|<', color: 'merge' },
                        { value: '어요', color: 'pattern', command: 'flyIn=130' },
                    ],
                    englishParts: [
                        { value: 'I drink', color: 'english' },
                        { value: '<|>', color: 'separate' },
                    ],
                    narration: [
                        { value: 'We select the 어요 ending.', styles: [], links: [] },
                    ],
                },
                },
                { name: 'Check for abbreviation', label: 'Check for abbreviation', type: 'parts', collapsed: true, states: ['checkAbbreviation'],
                    parts: {
                        koreanParts: [
                            { value: '마', color: 'example', command: 'noFadeIn' },
                            { value: '시', color: 'example', command: 'check2' },
                            { value: '>|<', color: 'merge' },
                            { value: '어', color: 'pattern' },
                            { value: '요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'I drink', color: 'english' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'The 시 and 어 combine into 셔 for ease of pronunciation.',
                                styles: [{ start: 4, end: 5, styledText: '시', style: 'highlight' },
                                    { start: 10, end: 11, styledText: '어', style: 'highlight' },
                                    { start: 25, end: 26, styledText: '셔', style: 'highlight' },
                                ], links: [],
                            },
                        ],
                    },
                },
                { name: 'Abbreviation', label: 'Abbreviation', type: 'parts', collapsed: true, states: ['abbreviate'],
                    parts: {
                        koreanParts: [
                            { value: '마', color: 'example', command: '' },
                            { value: '셔', color: 'example', command: '' },
                            { value: '>|<', color: 'merge' },
                            { value: '요', color: 'pattern', command: '' },
                        ],
                        englishParts: [
                            { value: 'I drink', color: 'english', command: '' },
                        ],
                        narration: [
                            { value: 'Now we have a polite informal sentence.', styles: [], links: [] },
                            { value: 'As the subject is not specified, we are not sure who is drinking.  This short sentence can be used as a polite suggestion or command - “Please drink.” or “Let’s drink."', styles: [], links: [] },
                            { value: 'You may add more to this phrase, such as a subject who drinks or an object to drink.', styles: [], links: [] },
                        ],
                    },
                },
            ] },
    },

    conjugationExample:  { type: 'conjugationExample', group: 'patterns', size: '100%', exercise: true, init:
        { fieldEdits: ['duplicate', 'move', 'delete', 'rename', 'hide', 'searchAndReplace'],
            fields: [
                { name: 'layout', type: 'choice', label: 'Layout', choices: ['Horizontal', 'Vertical', 'Single row'], value: 'Horizontal' },
                { name: 'example', label: 'Example', type: 'parts', states: [], hidden: true, collapsed: true,
                    parts: {
                        koreanParts: [
                            { value: '마시다', color: 'example' },
                        ],
                        englishParts: [
                            { value: 'to drink', color: 'english' },
                        ],
                    },
                },
                { name: 'Verb', label: 'Verb', type: 'parts', hidden: false, states: ['verb'], collapsed: true, parts: {
                    koreanParts: [
                        { value: '마시', color: 'example' },
                        { value: '다', color: '다' },
                        { value: '<|>', color: 'separate' },
                    ],
                    englishParts: [
                        { value: 'to drink', color: 'english' },
                        { value: '<|>', color: 'separate' },
                    ],
                    narration: [
                        { value: "The verb we'll use is for this example is 마시다 (to drink)", styles: [], links: [] },
                    ],
                },
                },
                { name: 'Stem the verb', label: 'Stem the verb', type: 'parts', states: ['partGoes'], collapsed: true,
                    parts: {
                        koreanParts: [
                            { value: '마시', color: 'example' },
                            { value: '다', color: '다', command: 'remove' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to drink', color: 'english' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'In Korean, only the verb stem stays when an ending follows, so the 다 goes away.', styles: [],
                                links: [{ start: 25, end: 29, linkText: 'stem', ref: 'Aside/Stem' }] },
                            { value: '마시 is the stem, which stays and contains the core meaning of the verb.', styles: [], links: [] },
                        ],
                    },
                },
                { name: 'Inspect', label: 'Inspect', type: 'parts', states: ['inspect'], collapsed: true,
                    parts: {
                        koreanParts: [
                            { value: '마', color: 'example', command: 'noFade' },
                            { value: '시', color: 'example', command: 'inspect=ㅣ,delay' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to drink', color: 'english', command: '' },
                        ],
                        narration: [
                            { value: 'To select the correct variant, we check the final vowel.', styles: [], links: [] },
                            { value: 'In this case, the vowel is ㅣ, not 아 or 오, so ...', styles: [], links: [] },
                        ],
                    },
                },
                { name: 'Select pattern', label: 'Select pattern', type: 'parts', states: ['select'], collapsed: true, parts: {
                    koreanParts: [
                        { value: '마시', color: 'example' },
                        { value: '>|<', color: 'merge' },
                        { value: '어요', color: 'pattern', command: 'flyIn=130' },
                    ],
                    englishParts: [
                        { value: 'I drink', color: 'english' },
                        { value: '<|>', color: 'separate' },
                    ],
                    narration: [
                        { value: 'We select the 어요 ending.', styles: [], links: [] },
                    ],
                },
                },
                { name: 'Check for abbreviation', label: 'Check for abbreviation', type: 'parts', collapsed: true, states: ['checkAbbreviation'],
                    parts: {
                        koreanParts: [
                            { value: '마', color: 'example', command: 'noFadeIn' },
                            { value: '시', color: 'example', command: 'check2' },
                            { value: '>|<', color: 'merge' },
                            { value: '어', color: 'pattern' },
                            { value: '요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'I drink', color: 'english' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'The 시 and 어 combine into 셔 for ease of pronunciation.',
                                styles: [{ start: 4, end: 5, styledText: '시', style: 'highlight' },
                                    { start: 10, end: 11, styledText: '어', style: 'highlight' },
                                    { start: 25, end: 26, styledText: '셔', style: 'highlight' },
                                ], links: [],
                            },
                        ],
                    },
                },
                { name: 'Abbreviation', label: 'Abbreviation', type: 'parts', collapsed: true, states: ['abbreviate'],
                    parts: {
                        koreanParts: [
                            { value: '마', color: 'example', command: '' },
                            { value: '셔', color: 'example', command: '' },
                            { value: '>|<', color: 'merge' },
                            { value: '요', color: 'pattern', command: '' },
                        ],
                        englishParts: [
                            { value: 'I drink', color: 'english', command: '' },
                        ],
                        narration: [
                            { value: 'Now we have a polite informal sentence.', styles: [], links: [] },
                            { value: 'As the subject is not specified, we are not sure who is drinking.  This short sentence can be used as a polite suggestion or command - “Please drink.” or “Let’s drink."', styles: [], links: [] },
                            { value: 'You may add more to this phrase, such as a subject who drinks or an object to drink.', styles: [], links: [] },
                        ],
                    },
                },
            ] },
    },

    introductoryAuxiliaryVerb:  { type: 'introductoryAuxiliaryVerb', group: 'patterns', size: '100%', exercise: true, init:
        { fieldEdits: ['duplicate', 'move', 'delete', 'rename', 'hide', 'searchAndReplace'],
            fields: [
                { name: 'layout', type: 'choice', label: 'Layout', choices: ['Horizontal', 'Vertical', 'Single row'], value: 'Horizontal' },
                {
                    name: 'pattern', label: 'Pattern', type: 'parts', states: ['pattern'],
                    parts: {
                        koreanParts: [
                            { value: '<|>', color: 'separate' },
                            { value: '-을 수 있다', color: 'pattern' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: '<|>', color: 'separate' },
                            { value: 'can', color: 'patternSubtitle' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'Let’s have a closer look...', styles: [], links: [] },
                            { value: '-을 수 있 adds the meaning of "can do" or "ability to do"...', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'appliedForm', label: 'Applied general form', type: 'parts', states: ['appliedForm'],
                    parts: {
                        koreanParts: [
                            { value: 'ACTION VERB', color: 'example' },
                            { value: '<|>', color: 'separate' },
                            { value: '-을 수 있다', color: 'pattern' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: '<|>', color: 'separate' },
                            { value: 'can', color: 'patternSubtitle' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: '+and adds this meaning to the action verb to which it is always attached.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'verb', label: 'Verb', type: 'parts',
                    hidden: false, states: ['verb'],
                    parts: {
                        koreanParts: [
                            { value: '받', color: 'example' },
                            { value: '다', color: '다' },
                            { value: '<|>', color: 'separate' },
                            { value: '-을 수 있다', color: 'pattern' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to receive', color: 'english' },
                            { value: '<|>', color: 'separate' },
                            { value: 'can', color: 'patternSubtitle' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'Let’s choose a verb, in this case 받다 (to receive)', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'stemify', label: 'Stem the verb', type: 'parts', states: ['partGoes'],
                    parts: {
                        koreanParts: [
                            { value: '받', color: 'example' },
                            { value: '다', color: '다', command: 'remove' },
                            { value: '<|>', color: 'separate' },
                            { value: '-을 수 있다', color: 'pattern' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to receive', color: 'english' },
                            { value: '<|>', color: 'separate' },
                            { value: 'can', color: 'patternSubtitle' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'In Korean, only the verb stem stays when an attachment follows, so the 다 goes away.', styles: [], links: [] },
                            { value: '받 is the stem, which stays and contains the core meaning of the verb.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'inspect', label: 'Inspect', type: 'parts', states: ['inspect'],
                    parts: {
                        koreanParts: [
                            { value: '받', color: 'example', command: 'inspect=ㄷ,delay,noFade' },
                            { value: '<|>', color: 'separate' },
                            { value: '-을 수 있다', color: 'pattern' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to receive', color: 'english' },
                            { value: '<|>', color: 'separate' },
                            { value: 'can', color: 'patternSubtitle' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'We select the appropriate attaching form based on whether the verb ends in a vowel or consonant.', styles: [], links: [] },
                            { value: "In this case, it's the consonant ㄷ, so ...", styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'select', label: 'Select pattern', type: 'parts', states: ['select'],
                    parts: {
                        koreanParts: [
                            { value: '받', color: 'example' },
                            { value: '<|>', color: 'separate' },
                            { value: '을 수 있다', color: 'pattern' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to receive', color: 'english' },
                            { value: '<|>', color: 'separate' },
                            { value: 'can', color: 'patternSubtitle' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'We select the 을 form.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'checkForAbbrev', label: 'Check for abbreviation', type: 'parts', states: ['checkAbbreviation'],
                    hidden: true,
                    parts: {
                        koreanParts: [
                            { value: '받', color: 'example', command: 'check2' },
                            { value: '<|>', color: 'separate' },
                            { value: '을 수 있다', color: 'pattern' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to receive', color: 'english' },
                            { value: '<|>', color: 'separate' },
                            { value: 'can', color: 'patternSubtitle' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'The 시 and 어 combine into 셔 for ease of pronunciation.', styles: [
                                { start: 4, end: 5, styledText: '시', style: 'highlight' },
                                { start: 10, end: 11, styledText: '어', style: 'highlight' },
                                { start: 25, end: 26, styledText: '셔', style: 'highlight' },
                            ], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'abbrev', label: 'Abbreviation', type: 'parts', states: ['abbreviate'],
                    hidden: true,
                    parts: {
                        koreanParts: [
                            { value: '받', color: 'example' },
                            { value: '<|>', color: 'separate' },
                            { value: '을 수 있다', color: 'pattern' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to receive', color: 'english' },
                            { value: '<|>', color: 'separate' },
                            { value: 'can', color: 'patternSubtitle' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'Now we have a polite informal sentence.', styles: [], links: [] },
                            { value: 'As the subject is not specified, we are not sure who is receiveing.  This short sentence can be used as a polite suggestion or command - “Please receive.” or “Let’s receive."', styles: [], links: [] },
                            { value: 'You may add more to this phrase, such as a subject who receives or an object to receive.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'stemifyAuxVerb', label: 'Stem the aux. verb', type: 'parts', states: ['partGoes'],
                    parts: {
                        koreanParts: [
                            { value: '받', color: 'example' },
                            { value: '<|>', color: 'separate' },
                            { value: '을 수 있', color: 'pattern' },
                            { value: '다', color: '다', command: 'remove' },
                            { value: '<|>', color: 'separate' },
                        ],
                        englishParts: [
                            { value: 'to receive', color: 'english' },
                            { value: '<|>', color: 'separate' },
                            { value: 'can', color: 'patternSubtitle' },
                            { value: '<|>', color: 'separate' },
                        ],
                        narration: [
                            { value: 'We should now conjugate the auxiliary verb, first removing its 다 dictionary-form ending,', styles: [], links: [] },
                            { value: 'and then replacing it with an appropriate ending...', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
                { name: 'selectEnding', label: 'Select ending', type: 'parts', states: ['select'], parts: {
                    koreanParts: [
                        { value: '받', color: 'example' },
                        { value: '<|>', color: 'separate' },
                        { value: '을 수 있', color: 'pattern' },
                        { value: '<|>', color: 'separate' },
                        { value: '어요', color: 'pattern', command: 'flyIn=130' },
                    ],
                    englishParts: [
                        { value: 'to receive', color: 'english' },
                        { value: '<|>', color: 'separate' },
                        { value: 'can', color: 'patternSubtitle' },
                        { value: '<|>', color: 'separate' },
                        { value: 'polite style ending', color: 'patternSubtitle' },
                    ],
                    narration: [
                        { value: 'selecting 어요, in this example, to form a polite present-tense sentence', styles: [], links: [] },
                    ],
                },
                collapsed: true,
                },
                {
                    name: 'finalPhrase', label: 'Final phrase', type: 'parts', states: ['final'],
                    parts: {
                        koreanParts: [
                            { value: '받', color: 'example' },
                            { value: '>|<', color: 'merge' },
                            { value: '을 수 있', color: 'pattern' },
                            { value: '>|<', color: 'merge' },
                            { value: '어요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: 'I can receive', color: 'english' },
                            { value: '>|<', color: 'merge' },
                            { value: '>|<', color: 'merge' },
                        ],
                        narration: [
                            { value: 'Now we have a polite informal sentence.', styles: [], links: [] },
                            { value: 'As the subject is not specified, we are not sure who is receiving.', styles: [], links: [] },
                            { value: 'You may add more to this phrase, such as a subject who receives and an object that can be received.', styles: [], links: [] },
                        ],
                    },
                    collapsed: true,
                },
            ] },
    },

    // The following need to be converted to the new PatternAnimation component scheme
    // // variant of pattern application to provide for double abbreviations in certain irregular conjugation cases
    // irregularConjugation:  { type: 'irregularConjugation', group: 'patterns', size: '100%', exercise: true, init:
    //     { fields: [
    //         {
    //             name: "example", label:"Example", type:"parts", states:[],
    //             parts: {
    //                 koreanParts: [{ value: "모르다", color: "example" }],
    //                 englishParts: [{ value: "to not know", color: "english" }]
    //             },
    //             collapsed: true
    //         },
    //         {
    //             name: "verb", label:"Verb", type:"parts", states:[ "verb" ],
    //             parts: {
    //                 koreanParts: [{ value: "모르", color: "example" },
    //                     { value: "다", color: "다" },
    //                     { value: "_", color: "separator" }],
    //                 englishParts: [{ value: "to not know", color: "english" },
    //                     { value: "_", color: "separator" }],
    //                 narration: [{ value: "The verb we'll use is for this example is 모르다 (to not know)", styles: [], links: [] }]
    //             },
    //             collapsed: true
    //         },
    //         {
    //             name: "stemify", label:"Stem the verb", type:"parts", states:[ "partGoes" ],
    //             parts: {
    //                 koreanParts: [{ value: "모르", color: "example", },
    //                     { value: "다", color: "다", command: "remove" },
    //                     { value: "_", color: "separator" }],
    //                 englishParts: [{ value: "to not know", color: "english" },
    //                     { value: "_", color: "separator" }],
    //                 narration: [{ value: "In Korean, only the verb stem stays when an ending follows, so the 다 goes away.", styles: [], links: [
    //                             { start: 25, end: 29, linkText: "stem", ref: "Aside/Stem" }
    //                         ]
    //                     },
    //                     { value: "모르 is the stem, which stays and contains the core meaning of the verb.", styles: [], links: [] }]
    //             },
    //             collapsed: true
    //         },
    //         {
    //             name: "inspect", label:"Inspect", type:"parts", states:[ "inspect" ],
    //             parts: {
    //                 koreanParts: [{ value: "모", color: "example", command: "inspect=ㅗ" },
    //                     { value: "르", color: "example", },
    //                     { value: "<|>", color: "separate" }],
    //                 englishParts: [{ value: "to not know", color: "english", }],
    //                 narration: [{ value: "To select the correct variant, we look back past the 르 and check the final vowel in the syllable before it.", styles: [], links: []
    //                     },
    //                     { value: "In this case, the vowel is ㅗ, so ...", styles: [], links: [] }]
    //             },
    //             collapsed: true
    //         },
    //         {
    //             name: "select", label:"Select pattern", type:"parts", states:[ "select" ],
    //             parts: {
    //                 koreanParts: [{ value: "모", color: "example", },
    //                     { value: "르", color: "example" },
    //                     { value: "<|>", color: "separate", },
    //                     { value: "아요", color: "pattern", command: "flyIn=130" }],
    //                 englishParts: [{ value: "I do not know", color: "english", },
    //                     { value: "_", color: "separator" }],
    //                 narration: [{ value: "We select the 아요 ending.", styles: [], links: [] }]
    //             },
    //             collapsed: true
    //         },
    //         {
    //             name: "checkForChange", label:"Check for change", type:"parts", states:[ "checkAbbreviation" ],
    //             parts: {
    //                 koreanParts: [{ value: "모", color: "example", command: "noFadeIn" },
    //                     { value: "르", color: "example", command: "check1" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "아요", color: "pattern", }],
    //                 englishParts: [{ value: "I do not know", color: "english" },
    //                     { value: "_", color: "separator" }],
    //                 narration: [{ value: "The 르 changes...", styles: [], links: [] }]
    //             },
    //             collapsed: true
    //         },
    //         {
    //             name: "change", label:"Change", type:"parts", states:[ "abbreviate" ],
    //             parts: {
    //                 koreanParts: [{ value: "모", color: "example", },
    //                     { value: "ㄹ", color: "example", },
    //                     { value: "ㄹ", color: "example" },
    //                     { value: "<|>", color: "separate", },
    //                     { value: "아요", color: "pattern" }],
    //                 englishParts: [{ value: "I do not know", color: "english", }],
    //                 narration: [{ value: "... into ㄹㄹ", styles: [], links: [] }]
    //             },
    //             collapsed: true
    //         },
    //         {
    //             name: "checkForAbbrev1", label:"Check for 1st abbreviation", type:"parts", states:[ "checkAbbreviation" ],
    //             parts: {
    //                 koreanParts: [{ value: "모", color: "example", command: "check2" },
    //                     { value: "ㄹ", color: "example", },
    //                     { value: "ㄹ", color: "example" },
    //                     { value: "<|>", color: "separate", },
    //                     { value: "아요", color: "pattern", }],
    //                 englishParts: [{ value: "I do not know", color: "english" },
    //                     { value: "_", color: "separator" }],
    //                 narration: [{ value: "The 모 and first ㄹ combine to form 몰.", styles: [], links: [] }]
    //             },
    //             collapsed: true
    //         },
    //         {
    //             name: "checkForAbbrev2", label:"Check for 2nd abbreviation", type:"parts", states:[ "checkAbbreviation" ],
    //             parts: {
    //                 koreanParts: [{ value: "몰", color: "example", },
    //                     { value: "ㄹ", color: "example", command: "check2" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "아", color: "pattern", },
    //                     { value: "요", color: "pattern" }],
    //                 englishParts: [{ value: "I do not know", color: "english" },
    //                     { value: "_", color: "separator" }],
    //                 narration: [{ value: "and then the second ㄹ and 아 combine to form 라.", styles: [], links: [] }]
    //             },
    //             collapsed: true
    //         },
    //         {
    //             name: "finalFrom", label:"Final form", type:"parts", states:[ "abbreviate" ],
    //             parts: {
    //                 koreanParts: [{ value: "몰", color: "example", },
    //                     { value: "라", color: "example", },
    //                     { value: "<|>", color: "separate", },
    //                     { value: "요", color: "pattern", }],
    //                 englishParts: [{ value: "I do not know", color: "english", }],
    //                 narration: [{ value: "And we now have the final form - 모라요 (I do not know)", styles: [], links: [] }]
    //             },
    //             collapsed: true
    //         }
    //     ]}
    // },
    //
    // introductoryAttachParticle:  { type: 'introductoryAttachParticle', group: 'patterns', size: '100%', exercise: true, init:
    //     { fields: [
    //         {
    //             name: "pattern",
    //             label: "Pattern",
    //             type: "parts",
    //             states: ["pattern"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "<|>", color: "separate" },
    //                     { value: "이", color: "pattern" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 englishParts: [
    //                     { value: "<|>", color: "separate" },
    //                     { value: "subject marker", color: "patternSubtitle" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 narration: [
    //                     { value: "Let’s have a closer look at one of the variants, 이", styles: [], links: [] },
    //                     { value: "이 marks the subject of a sentence or verb phrase", styles: [], links: [] }
    //                 ]
    //             },
    //             collapsed: true,
    //         },
    //         {
    //             name: "appliedForm",
    //             label: "Applied general form",
    //             type: "parts",
    //             states: ["appliedForm"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "NOUN", color: "example", command: "separate" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "이", color: "pattern" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 englishParts: [
    //                     { value: "<|>", color: "separate" },
    //                     { value: "subject marker", color: "patternSubtitle" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 narration: [
    //                     { value: "+It is always attached to a noun.", styles: [], links: [] },
    //                     {
    //                         value: "We select 이 when the noun ends with a consonant, and 가 when the noun ends with a vowel.",
    //                         styles: [],
    //                         links: []
    //                     }
    //                 ]
    //             },
    //             collapsed: true,
    //         },
    //         {
    //             name: "target",
    //             label: "Choose a target",
    //             type: "parts",
    //             hidden: true,
    //             states: ["target"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "비빔밥", color: "example" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "이", color: "pattern" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 englishParts: [
    //                     { value: "bibimbap", color: "english" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "subject marker", color: "patternSubtitle" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 narration: [
    //                     {
    //                         value: "Let’s choose a noun, in this case 비빔밥 (a favorite Korean dish)",
    //                         styles: [],
    //                         links: []
    //                     },
    //                     { value: "As you can see, 비빔밥 ends with consonant ㅂ.", styles: [], links: [] }
    //                 ]
    //             },
    //             collapsed: true,
    //         },
    //         {
    //             name: "inspect",
    //             label: "Inspect",
    //             type: "parts",
    //             states: ["inspect"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "비빔", color: "example" },
    //                     { value: "밥", color: "example", command: "inspect=ㅂ, delay" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "이", color: "pattern" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 englishParts: [
    //                     { value: "bibimbap", color: "english" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "subject marker", color: "patternSubtitle" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 narration: [
    //                     {
    //                         value: "Let’s choose a noun, in this case 비빔밥 (a favorite Korean dish)",
    //                         styles: [],
    //                         links: []
    //                     },
    //                     { value: "As you can see, 비빔밥 ends with consonant ㅂ, so...", styles: [], links: [] }
    //                 ]
    //             },
    //             collapsed: true,
    //         },
    //         {
    //             name: "select",
    //             label: "Select pattern",
    //             type: "parts",
    //             states: ["select"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "비빔밥", color: "example", command: "merge" },
    //                     { value: "<|>", color: "separate", command: "" },
    //                     { value: "이", color: "pattern", command: "" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 englishParts: [
    //                     { value: "bibimbap", color: "english" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 narration: [
    //                     {
    //                         value: "We select the 이 variant, attach it to the noun (with no spaces between!)...",
    //                         styles: [],
    //                         links: []
    //                     },
    //                     { value: "...and we now have a subject.", styles: [], links: [] },
    //                     { value: "Let's make a complete sentence by adding a verb phrase...", styles: [], links: [] }
    //                 ]
    //             },
    //             collapsed: true,
    //         },
    //         {
    //             name: "checkForAbbrev",
    //             label: "Check for abbreviation",
    //             type: "parts",
    //             hidden: true,
    //             states: ["checkAbbreviation"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "마", color: "example" },
    //                     { value: "시", color: "example", command: "check2" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "이", color: "pattern" }
    //                 ],
    //                 englishParts: [{ value: "I drink", color: "english" }, { value: "_", color: "separator" }],
    //                 narration: [
    //                     {
    //                         value: "The 시 and 어 combine into 셔 for ease of pronunciation.",
    //                         styles: [
    //                             { start: 4, end: 5, styledText: "시", style: "highlight" },
    //                             { start: 10, end: 11, styledText: "어", style: "highlight" },
    //                             { start: 25, end: 26, styledText: "셔", style: "highlight" }
    //                         ],
    //                         links: []
    //                     }
    //                 ]
    //             },
    //             collapsed: true,
    //         },
    //         {
    //             name: "abbrev",
    //             label: "Abbreviation",
    //             type: "parts",
    //             hidden: true,
    //             states: ["abbreviate"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "마", color: "example" },
    //                     { value: "셔", color: "example" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "-이", color: "pattern" }
    //                 ],
    //                 englishParts: [{ value: "I drink", color: "english" }, { value: "<|>", color: "separate" }],
    //                 narration: [{ value: "Now we have a polite informal sentence.", styles: [], links: [] }]
    //             },
    //             collapsed: true,
    //         },
    //         {
    //             name: "completeSentence",
    //             label: "Complete the sentence",
    //             type: "parts",
    //             states: ["completeSentence"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "비빔밥", color: "example", command: "" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "이", color: "pattern" },
    //                     { value: " ", color: "space" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "맛있어요", color: "example", command: "flyIn=130" }
    //                 ],
    //                 englishParts: [
    //                     { value: "bibimbap", color: "english" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: " ", color: "space" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "is delicious", color: "english" }
    //                 ],
    //                 narration: [
    //                     { value: "... for example, 맛있어요 (is delicious)", styles: [], links: [] },
    //                     {
    //                         value: "The 이 we attached to 비빔밥 marks it as the subject of the descriptive verb phrase, 맛있어요.",
    //                         styles: [],
    //                         links: []
    //                     }
    //                 ]
    //             },
    //             collapsed: true,
    //         },
    //     ]}
    // },
    //
    // // animated pattern application for particle attachement, such as subject particles to nouns, with 3rd section for adding a predicate to complete a sentence
    // attachParticle:  { type: 'attachParticle', group: 'patterns', size: '100%', exercise: true, init:
    //     { fields: [
    //         {
    //             name: "example",
    //             label: "Example",
    //             type: "parts",
    //             hidden: false,
    //             states: [],
    //             parts: {
    //                 koreanParts: [{ value: "사람들", color: "example" }],
    //                 englishParts: [{ value: "people", color: "english" }]
    //             },
    //             collapsed: true,
    //         },
    //         {
    //             name: "target",
    //             label: "Choose a target",
    //             type: "parts",
    //             hidden: false,
    //             states: ["target"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "사람들", color: "example" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 englishParts: [
    //                     { value: "people", color: "english" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 narration: [
    //                     { value: "Let’s take 사람들 as an example. ", styles: [], inks: [] }
    //                 ]
    //             },
    //             collapsed: false,
    //         },
    //         {
    //             name: "inspect",
    //             label: "Inspect",
    //             type: "parts",
    //             states: ["inspect"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "사람", color: "example" },
    //                     { value: "들", color: "example", command: "inspect=ㄹ" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "<|>", color: "separate" },
    //                 ],
    //                 englishParts: [
    //                     { value: "people", color: "english" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "<|>", color: "separate", }
    //                 ],
    //                 narration: [
    //                     { value: "As 사람들 ends with consonant ㄹ, so...", styles: [], links: [] }
    //                 ]
    //             },
    //             collapsed: false,
    //             hidden: false,
    //         },
    //         {
    //             name: "select",
    //             label: "Select pattern",
    //             type: "parts",
    //             states: ["select"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "사람들", color: "example", command: "merge" },
    //                     { value: "<|>", color: "separate", command: "" },
    //                     { value: "이", color: "pattern", command: "flyIn=130" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 englishParts: [
    //                     { value: "people", color: "english" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 narration: [
    //                     { value: "we should choose 이 variant.", styles: [], links: [] },
    //                     { value: "...and we now have a subject.", styles: [], links: [] },
    //                     { value: "Let's make a complete sentence by adding a verb phrase...", styles: [], links: [] }
    //                 ]
    //             },
    //             collapsed: false,
    //             hidden: false,
    //         },
    //         {
    //             name: "checkForAbbrev",
    //             label: "Check for abbreviation",
    //             type: "parts",
    //             hidden: true,
    //             states: ["checkAbbreviation"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "마", color: "example" },
    //                     { value: "시", color: "example", command: "check2" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "이", color: "pattern" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 englishParts: [
    //                     { value: "I drink", color: "english" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 narration: [
    //                     { value: "The 시 and 어 combine into 셔 for ease of pronunciation.", styles: [], links: [] }
    //                 ]
    //             },
    //             collapsed: true,
    //         },
    //         {
    //             name: "abbrev",
    //             label: "Abbreviation",
    //             type: "parts",
    //             hidden: true,
    //             states: ["abbreviate"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "마", color: "example" },
    //                     { value: "셔", color: "example" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "-이", color: "pattern" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 englishParts: [
    //                     { value: "I drink", color: "english" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "<|>", color: "separate" }
    //                 ],
    //                 narration: [
    //                     { alue: "Now we have a polite informal sentence.",  styles: [], links: [] }
    //                 ]
    //             },
    //             collapsed: true,
    //         },
    //         {
    //             name: "completeSentence",
    //             label: "Complete the sentence",
    //             type: "parts",
    //             states: ["completeSentence"],
    //             parts: {
    //                 koreanParts: [
    //                     { value: "사람들", color: "example", command: "" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "이", color: "pattern" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: " ", color: "space" },
    //                     { value: "운동해요", color: "example", command: "flyIn=130" }
    //                 ],
    //                 englishParts: [
    //                     { value: "people", color: "english" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: "<|>", color: "separate" },
    //                     { value: " ", color: "space" },
    //                     { value: "are doing exercise", color: "english" }
    //                 ],
    //                 narration: [
    //                     { value: "... for example, 운동해요 (do exercise)", styles: [], links: [] },
    //                     { value: "The 이 we attached to 사람들 marks it as the agent who is doing the action of the verb phrase, 운동해요.", styles: [], links: [] }
    //                 ]
    //             },
    //             collapsed: false,
    //         }
    //     ]}
    // },
    
    phrase: { type: 'phrase', group: 'examples', size: '100%', init:
        { fields: [
            { name: 'phrase', label: 'Example phrase', type: 'underlinedParts',
                parts: {
                    koreanParts: [
                        { value: '먹', color: 'verb', underline: false },
                        { value: '는', color: 'orange', underline: false },
                        { value: ' ', color: 'space', underline: false },
                        { value: '음식', color: 'noun', underline: false },
                    ],
                    englishParts: [
                        { value: 'food', color: 'red' },
                        { value: 'that', color: 'orange' },
                        { value: '(I) eat', color: 'verb' },
                    ],
                },
            },
        ] },
    },
    matchTheLetters: { type: 'matchTheLetters', group: 'practice', exercise: true, size: '100%', init:
        { fieldEdits: ['duplicate', 'delete'],
            fields: [
            { name: 'buttonSet1', label: 'Letter pair 1', type: 'parts',
                parts: {
                    koreanParts: [{ value: 'ㅏ', color: 'dark' }],
                    englishParts: [{ value: 'a', color: 'dark' }],
                },
            },
            { name: 'buttonSet2', label: 'Letter pair 2', type: 'parts',
                parts: {
                    koreanParts: [{ value: 'ㅓ', color: 'dark' }],
                    englishParts: [{ value: 'eo', color: 'dark' }],
                },
            },
            { name: 'buttonSet3', label: 'Letter pair 3', type: 'parts',
                parts: {
                    koreanParts: [{ value: 'ㅗ', color: 'dark' }],
                    englishParts: [{ value: 'o', color: 'dark' }],
                },
            },
            { name: 'buttonSet4', label: 'Letter pair 4', type: 'parts',
                parts: {
                    koreanParts: [{ value: 'ㅜ', color: 'dark' }],
                    englishParts: [{ value: 'u', color: 'dark' }],
                },
            },
            { name: 'buttonSet5', label: 'Letter pair 5', type: 'parts',
                parts: {
                    koreanParts: [{ value: 'ㅣ', color: 'dark' }],
                    englishParts: [{ value: 'ee', color: 'dark' }],
                },
            },
        ] },
    },
    staticPattern:  { type: 'staticPattern', group: 'patterns', size: '100%', init:
        { fieldEdits: ['duplicate', 'move', 'delete', 'hide', 'searchAndReplace'],
            fields: [
                {
                    name: 'base', label: 'Base', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '바쁘', color: 'example' },
                            { value: '다', color: '다' },
                        ],
                        englishParts: [
                            { value: 'to be busy', color: 'english' },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'pattern', label: 'Pattern', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '아요', color: 'example' },
                        ],
                        englishParts: [
                            { value: 'to be busy', color: 'english' },
                        ],
                    },
                    collapsed: true,
                },
                {
                    name: 'becomes', label: 'Becomes', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '바빠', color: 'example' },
                            { value: '요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: '(I) am busy', color: 'english' },
                        ],
                    },
                    collapsed: true,
                },
                { name: 'change', label: 'Change annotation', type: 'text', value: 'ㅡ drops' },
            ],
        },
    },

    patternCallout:  { type: 'patternCallout', group: 'patterns', init:
        { fieldEdits: ['duplicate', 'move', 'delete', 'hide', 'searchAndReplace'],
            fields: [
                { name: 'explanation', type: 'text', label: 'Explanation', value: 'Only 돕다 (to help) and 곱다 (to be beautiful) takes 아요 and its ㅂ changes into 오 before 아요. 돕다 (도와요)', links: [], styles: [] },
                { name: 'example1From', label: 'Example 1 From', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '돕', color: 'example' },
                            { value: '다', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: ' ', color: 'english', hidden: true },
                        ],
                    },
                    collapsed: true,
                },
                { name: 'example1To', label: 'Example 1 To', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '도', color: 'example' },
                            { value: '와요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: ' ', color: 'english', hidden: true },
                        ],
                    },
                    collapsed: true,
                },
                { name: 'example2From', label: 'Example 2 From', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '곱', color: 'example' },
                            { value: '다', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: ' ', color: 'english', hidden: true },
                        ],
                    },
                    collapsed: true,
                },
                { name: 'example2To', label: 'Example 2 To', type: 'parts',
                    parts: {
                        koreanParts: [
                            { value: '고', color: 'example' },
                            { value: '와요', color: 'pattern' },
                        ],
                        englishParts: [
                            { value: ' ', color: 'english', hidden: true },
                        ],
                    },
                    collapsed: true,
                },
            ],
        },
    },

    startButton:  { type: 'startButton', group: 'navigation', init:
        { fields: [
            { name: 'label', type: 'text', label: 'Label', value: 'Start', links: [], styles: [] },
        ] } },

    finishButton:  { type: 'finishButton', group: 'navigation', init:
        { fields: [
            { name: 'label', type: 'text', label: 'Label', value: 'Finish', links: [], styles: [] },
        ] } },

    continueButton:  { type: 'continueButton', group: 'navigation' },

    hintButton:  { type: 'hintButton', group: 'buttons', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Hint text', value: '', links: [], styles: [] },
        ] } },

    startPageTitle: { type: 'startPageTitle', group: 'headings', size: '100%', init: {
        fields: [
            { name: 'startPageTitle', label: 'Pattern Title', src: 'lesson.startPageTitle' },
            { name: 'levelTitle', label: 'Level', src: 'lesson.levelTitle' },
            { name: 'subtitle', label: 'Pattern subtitle', src: 'lesson.subtitle' },
            { name: 'listingLabel', label: 'Listing text', src: 'lesson.listingLabel' },
            { name: 'tags', label: 'Tags', src: 'lesson.tags' },
        ] } },

    patternTitle: { type: 'patternTitle', group: 'headings', size: '100%', init: {
        fields: [
            { name: 'title', label: 'Pattern Title', type: 'text', src: 'lesson.title' },
            { name: 'subtitle', label: 'Pattern subtitle', type: 'text', src: 'lesson.subtitle' },
            { name: 'listingLabel', label: 'Listing text', type: 'text', src: 'lesson.listingLabel' },
        ] } },

    customPatternTitle: { type: 'customPatternTitle', group: 'headings', size: '100%', init: {
        fields: [
            { name: 'title', type: 'text', label: 'Pattern Title', value: 'Pattern', links: [], styles: [] },
            { name: 'subtitle', type: 'text', label: 'Pattern subtitle', value: 'subtitle', links: [], styles: [] },
            { name: 'listingLabel', type: 'text', label: 'Listing text', value: 'listing', links: [], styles: [] },
        ] } },

    bubbleTextUp: { type: 'bubbleTextUp', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Text', value: 'bubble text', links: [], styles: [] },
        ] } },

    bubbleTextDown: { type: 'bubbleTextDown', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Text', value: 'bubble text', links: [], styles: [] },
        ] } },

    callToActionText: { type: 'callToActionText', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Action', value: 'call to action', links: [], styles: [] },
        ] } },

    directionsText: { type: 'directionsText', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Directions', value: 'directions', links: [], styles: [] },
        ] } },

    irregularTitle: { type: 'irregularTitle', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Title', value: 'title', links: [], styles: [] },
        ] } },

    text: { type: 'text', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Text', value: '', links: [], styles: [] },
        ] } },

    vocabCard: { type: 'vocabCard', group: 'vocab', size: '100%', init:
        { fields: [
            { name: 'word', type: 'text', label: 'Word', value: '', links: [], styles: [] },
            { name: 'pronunciation', type: 'text', label: 'Pronunciation', value: '', links: [], styles: [] },
            { name: 'english', type: 'text', label: 'Meaning', value: '', links: [], styles: [] },
        ] },
    },
    letterCard: { type: 'letterCard', group: 'letters', size: '100%', init:
        { fields: [
            { name: 'letter', type: 'text', label: 'Korean pronunciation', value: '와', links: [], styles: [] },
            { name: 'pronunciation', type: 'text', label: 'English pronunciation', value: '[wa]', links: [], styles: [] },
            { name: 'graphic', type: 'graphic', label: 'Graphic', url: '', mimeType: ''},
            { name: 'scale', type: 'text', label: 'Graphic scale', value: '1.0', links: [], styles: [] },
            { name: 'voicing', type: 'choice', label: 'Voicing', choices: ['Male slow', 'Male normal', 'Male fast', 'Female slow', 'Female normal', 'Female fast'], value: 'Male slow' },
        ] },
    },
    wordCard: { type: 'wordCard', group: 'letters', size: '100%', init:
        { fields: [
            { name: 'word', type: 'text', label: 'Korean word', value: '오이', links: [], styles: [] },
            { name: 'pronunciation', type: 'text', label: 'English word', value: '[o-ee]', links: [], styles: [] },
            { name: 'graphic', type: 'graphic', label: 'Graphic', url: '', mimeType: ''},
            { name: 'scale', type: 'text', label: 'Graphic scale', value: '1.3', links: [], styles: [] },
            { name: 'voicing', type: 'choice', label: 'Voicing', choices: ['Male slow', 'Male normal', 'Male fast', 'Female slow', 'Female normal', 'Female fast'], value: 'Male slow' },
        ] },
    },
    helpBubble: { type: 'helpBubble', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Help bubble', value: 'help as you need it...', links: [], styles: [] },
            { name: 'placement', type: 'choice', label: 'Placement', choices: ['Above', 'Below', 'Right', 'Left'], value: 'Above' },
        ] } },
    annotation: { type: 'annotation', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Annotation', value: 'say what you want...', links: [], styles: [] },
        ] } },
    imageAndTextTitle: { type: 'imageAndTextTitle', group: 'text', size: '100%', init:
        { fields: [
            { name: 'text', type: 'text', label: 'Title', value: 'say what you want...', links: [], styles: [] },
        ] } },
    batchimCard: { type: 'batchimCard', group: 'letters', size: '100%', init:
        { fields: [
            { name: 'word', type: 'text', label: 'Korean word', value: '국', links: [], styles: [] },
            { name: 'pronunciation', type: 'text', label: 'Pronunciation', value: '[guk]', links: [], styles: [] },
            { name: 'translation', type: 'text', label: 'English word', value: ' ', links: [], styles: [] },
            { name: 'imageGraphic', type: 'graphic', label: 'image', url: '', mimeType: ''},
            { name: 'imageScale', type: 'text', label: 'Image scale', value: '0.8', links: [], styles: [] },
            { name: 'textGraphic', type: 'graphic', label: 'text SVG', url: '', mimeType: ''},
            { name: 'textScale', type: 'text', label: 'Text SVG scale', value: '1.0', links: [], styles: [] },
            { name: 'voicing', type: 'choice', label: 'Voicing', choices: ['Male slow', 'Male normal', 'Male fast', 'Female slow', 'Female normal', 'Female fast'], value: 'Male slow' },
        ] } },
    imageCard: { type: 'imageCard', group: 'letters', size: '100%', init:
        { fields: [
            { name: 'graphic', type: 'graphic', label: 'image or SVG', url: '', mimeType: ''},
            { name: 'scale', type: 'text', label: 'I scale', value: '1.0', links: [], styles: [] },
        ] } },
    textCard: { type: 'textCard', group: 'letters', size: '100%', init:
        { fields: [
            { name: 'cardTitle', type: 'text', label: 'Title', value: 'How were they made?', links: [], styles: [] },
            { name: 'text', type: 'text', label: 'Text', value: 'In 1443, King Sejong and a group of scholars created...', links: [], styles: [] },
        ] },
    },
    idiomImageCard: { type: 'idiomImageCard', group: 'letters', size: '100%', init:
        { fields: [
            { name: 'graphic', type: 'graphic', label: 'image or SVG', url: '', mimeType: ''},
            { name: 'scale', type: 'text', label: 'I scale', value: '1.0', links: [], styles: [] },
        ] } },
    idiomTextCard: { type: 'idiomTextCard', group: 'letters', size: '100%', init:
        { fields: [
            { name: 'cardTitle', type: 'text', label: 'Title', value: '벼 이삭은 익을수록 고개를 숙인다', links: [], styles: [] },
            { name: 'text', type: 'text', label: 'Text', value: '한국 속담중에는 "벼 이삭은 익을수록 고개를 숙인다"라는 말이 있습니다...', links: [], styles: [] },
        ] },
    },
};

// types for add/insert node-tree context menus
export const nodeAddTypes = { 'section': {}, 'page': {} };
export const pagePaths = {};
export const pageInits = {};
export const pageTypeDefs = {};

// build the typeMaps, injected at each level of the lesson-def structures
export const lessonTypeMap = lessonTypes.reduce((m, lessonType) => {
    m[lessonType.type] = lessonType;
    lessonType.typeMap = lessonType.sections.reduce((m, s) => {
        nodeAddTypes.section[lessonType.type] = nodeAddTypes.section[lessonType.type] || {};
        nodeAddTypes.section[lessonType.type][s.type] = s;
        m[s.type] = s;
        s.typeMap = s.pages.reduce((m, p, i) => {
            nodeAddTypes.page[lessonType.type] = nodeAddTypes.page[lessonType.type] || {};
            nodeAddTypes.page[lessonType.type][p.type] = p;
            p.componentName = p.type;
            pagePaths[lessonType.type] = pagePaths[lessonType.type] || {}; pagePaths[lessonType.type][s.type] = (pagePaths[lessonType.type][s.type] || []);
            pagePaths[lessonType.type][s.type].push(p.type);
            if (p.init) pageInits[p.type] = p.init;
            pageTypeDefs[p.type] = p;
            p.type = `${p.type}-p${i + 1}`;
            m[p.type] = p;
            p.typeMap = p.steps.reduce((m, step, i) => {
                // step typeDefs need to be distinguished with unique type names
                step.type = `step-${i + 1}`;
                m[step.type] = step;
                // instance the element type from elements type table
                step.elements = step.elements.map(en => {
                    const [type, name, size, exercise, managedByPage, init] = typeof en === 'string' ? [en, en, null, null, null] : [en.type, en.name, en.size, en.exercise, en.managedByPage, en.init];
                    // console.log(type, elements[type]);
                    // console.log(type, name);
                    const e = deepClone(elements[type]);
                    e.name = name;
                    e.type = type;
                    e.componentName = e.type;
                    if (managedByPage) e.managedByPage = managedByPage;
                    if (size) e.size = size;
                    if (exercise) e.exercise = exercise;
                    if (init) e.init = deepClone(init);
                    return e;
                });
                step.typeMap = step.elements.reduce((m, v) => {
                    m[v.type] = v;
                    return m;
                }, {});
                return m;
            }, {});
            return m;
        }, {});
        return m;
    }, {});
    return m;
}, {});

console.log('lessonTypeMap', lessonTypeMap);

// build typeDefPathName to typeDef table and gather element type closures by page & all-up
//   typeDefs are accessed by typeDef pathname, herein constructed by recursing down the lesson-def structure
export const typeDefMap = {
    root: { typeMap: lessonTypeMap, lessons: lessonTypes },
    lesson: { typeMap: {}, type: 'lesson', name: '-- lesson --', sections: [], pathName: 'lesson' },
    section: { typeMap: {}, type: 'section', name: '-- section --', pages: [{ typeMap: {}, type: 'page', name: '-- page --', steps: [], pathName: 'page' }], pathName: 'section' },
    page: { typeMap: {}, type: 'page', name: '-- page --', steps: [], pathName: 'page' },
    step: { typeMap: {}, type: 'step', name: '-- step --', elements: [], pathName: 'step' },
};

const buildTypeDefMap = (typeMap, parentPath) => {
    for (const type in typeMap) {
        const typeDef = typeMap[type];
        const typeDefPath = parentPath ? `${parentPath}/${typeDef.name || type}` : type;
        typeDefMap[typeDefPath] = typeMap[type];
        typeDef.pathName = typeDefPath;
        if (typeDef.type !== 'element' && typeDef.typeMap)
            buildTypeDefMap(typeDef.typeMap, typeDefPath);
    }
};
buildTypeDefMap(lessonTypeMap);

console.log('typeDefMap', typeDefMap);
console.log('elements', elements);
console.log('pagePaths', pagePaths);
console.log('pageInits', pageInits);
console.log('pageTypeDefs', pageTypeDefs);

// --------- default node-class initializers ----------------

export const defaultNodeInits = {
    lesson: { name: '-- untitled --', type: 'lesson', modes: ['step', 'autoplay'], status: 'Editing', group: 'Beginner' },
    section: { name: '-- untitled --', type: 'section', modes: ['step', 'autoplay'], notInSectionNav: false },
    page: { name: '-- untitled --', type: 'page', modes: ['step', 'autoplay'] },
    step: { name: '-- untitled --', type: 'step', stepTime: '2.5', stepMode: 'add', transition: 'cut', modes: ['step', 'autoplay'] },
    element: { name: '-- untitled --', type: 'element', modes: ['step', 'autoplay'] },
};
